(function() {
  "use strict";

  angular.module("sempraWebapp").constant("srTranslations", {
    MESSAGE:"Poruka",
    ERROR_TITLE:"Greška",
    ERROR_MESSAGE:"Desila se greška tokom izvršavanja operacije.",
    ERROR_LOGIN:"Greška prilikom prijavljivanja. Email adresa je nepoznata ili se lozika ne podudara. Molimo Vaš pokušajte ponovo.",
    ERROR_LOGIN_ROLE:"Uloga za trenutnu aplikaciju nije validna",
    OK:"OK",
    CANCEL:"Otkaži",
    YES:"Da",
    NO:"Ne",
    UNLIMITED:"Neograničeno",
    FROM:"Od",
    TO:"Do",
    DELETE:"Obriši",
    SIGN_OUT:"Odjavi se",
    NAME:"Ime",
    DATE:"Datum",
    PIECES:"komada",
    HOURS:"Sati",
    DAYS:"Dani",
    MONTH:"Mesec",
    MONTHS:"Meseci",
    YEAR:"Godina",
    BOX:"Box",
    SEARCH:"Pretraži",
    ALL_USERS:"Svi korisnici",
    ARE_YOU_SURE:"Sigurni ste?",
    BACK:"Nazad",
    AMOUNT:"Opis",
    DESCRIPTION:"Opis",
    FORGOT_PASSWORD_ERROR_MSG:"Da li ste sigurni",
    REQUIRED_FIELD:"Polje je obavezno",
    LOGOUT_TITLE:"Da li ste sigurni da želite da se odjavite",
    LOGOUT_MSG:"Sve nesačuvane promene će biti obrisane",
    ACTIVATION_ACCOUNT:"Uspešno ste aktivirali nalog, nastavite ka ekranu za prijavu",
    UNKNOWN_ERRROR_NOTIFICATION:"Nastavite",
    CONTINUE:"Desila se nepoznata greška",
    DATA_NOT_AVAILABLE:"Podaci nisu pronađeni",
    SELECT:"Izaberi",
    SELECT_CURRENCY:"Odaberite valutu",
    UPLOAD:"Pošalji",
    PHONE:"Telefon",
    WEBSITE:"Internet stranica",
    WORKING_HOURS:"Radno vreme",
    INSERT:"Unesi",
    TEXT:"Tekst",
    CREATED:"Kreirana",
    VALID_UNTIL:"Traje do",
    SAVE:"Sačuvaj",
    TOKENS:"Žetona",
    DELETE_COMPANY_HISTORY:"Obrisati istoriju kompanije?",
    DELETE_COMPANY_HISTORY_MESSAGE:"Upozorenje: Nakon pritiskanja ovog dugmeta, sve transakcije Vaše autoperionice će biti trajno obrisane! Ovi podaci ne mogu biti vraćeni nakon brisanja.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Da li ste sigurni da želite trajno obrisati sve podatke o transakcijama?",
    HISTORY_SUCCESSFULY_DELETED:"Istorija uspešno obrisana",
    HELP:"Pomoć",
    VALUE:"Vrednost",
    ACTIVATING_ACCOUNT_ERROR:"Desila se greška prilikom aktivacije vašeg R2W naloga.Molimo pokušajte ponovo i ako problem i dalje postoji kontaktirajte support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Dobrodošli u Karcher perionicu",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Dobrodošli na R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Molimo upišite i ponovite vašu lozinku da bi aktivirali vaš R2W nalog. Bićete automatski prijavljeni na sistem nakon uspešne verifikacije lozinke",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Vaše podatke možete menjati kasnije u aplikaciji",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Karcher autoperionica",
    RESET_PASSWORD_WELCOME_MSG:"R2W autoperionica",
    RESET_PASSWORD_WELCOME_MSG_2:"Molimo vas da unesete novu lozinku i potvrdite je kako biste resetovali staru lozinku. Bićete automatski prijavljeni u aplikaciju nakon uspešnog resetovanja",
    RESET_PASSWORD_WELCOME_MSG_3:"Možete kasnije promeniti svoje korisničke podešavanja u aplikaciji",
    ENTER_NEW_PASSWORD:"Unesite novu lozinku",
    REPEAT_NEW_PASSWORD:"Ponovite lozinku",
    PASSWORD_MIN_LENGTH:"Lozinka mora imati barem 8 karaktera",
    PASSWORD_MAX_LENGHT:"Lozinka nesme imati više od 32 karaktera",
    PASSWORD_PATTERN:"Lozinka mora sadržati barem jedno veliko i jedno malo slovo",
    PASSWORD_MATCH:"Lozinke nisu identične",
    ACTIVATE:"Aktiviraj",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Uspešno ste poslali zahtev. Molimo vas da provjerite e-mail za potvrdu",
    VALIDATION_REQUIRED:"Obavezno polje",
    VALIDATION_EMAIL:"Neispravna email adresa",
    VALIDATION_INTEGER_NUMBER:"Vrednost mora biti celobrojan broj",
    VALIDATION_HOURS_VALUE:"Vrednost mora biti između 0-23",
    VALIDATION_MINUTES_VALUE:"Vrednost mora biti između 0-59",
    VALIDATION_NOT_A_DATE:"Uneta vrednost nije datum",
    VALIDATION_FROM:"Datum veći od krajnjeg datuma",
    VALIDATION_TO:"Datum manji od početnog datuma",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Taj podatak već postoji u bazi podataka",
    PASSWORD_VALIDATION_PATTERN_NEW:"Lozinka mora sadržati barem jedno veliko i malo slovo i jedan broj. Prazna polja takođe nisu dozvoljena.",
    VALIDATION_PERCENT_VALUE:"Vrednost mora biti između 1-999",
    NUMBERS_ONLY_100:"Broj do 100",
    NUMBERS_ONLY_1000:"Broj do 1000",
    POSITIVE_NUMBERS_ONLY:"Samo pozitivan broj",
    GRID_PAGER_PAGE:"Stranica",
    GRID_PAGER_ROWS_PER_PAGE:"Redova po stranici",
    GRID_PAGER_PAGE_OF:"od",
    BREAD_CRUMBS_HOME:"Početna",
    BREAD_CRUMBS_DASHBOARD_TECH:"Pregled perionica",
    BREAD_CRUMBS_DETAILS:"Detalji",
    BREAD_CRUMBS_SETTINGS:"Podešavanja",
    BREAD_CRUMBS_WORKING_HOURS:"Radno vreme",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Ukupno novca po danima",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Prosečno novca po satima",
    BREAD_CRUMBS_NEW_USER_GROUP:"Kreiranje korisničke grupe",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Izmena korisničke grupe",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Kreiranje šablona kampanje",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Izmena šablona kampanje",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Kreiranje kampanje",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Izmena kampanje",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Pregled finansija za period",
    LOGIN:"Prijava",
    EMAIL:"E-mail",
    PASSWORD:"Lozinka",
    LANGUAGE:"Jezik",
    FORGOT_PASSWORD:"Zaboravljena lozinka?",
    SUBMIT:"Potvrdi",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Broj tekućih alarma:",
    HEADER_VIEW_ALL_ALARMS:"Svi alarmi...",
    HEADER_MY_ACCOUNT:"Moj nalog",
    HEADER_ACCOUNT_MANAGEMENT:"Upravljanje nalozima",
    ACCOUNT_ALREADY_EXIST:"Email adresa već postoji",
    NEWSLETTER_CONFIRMATION:"Pošaljite e-mail obaveštenje o stanju alarma",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Dnevni pregled finansija",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Pregled perionica",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Perionice",
    ASIDE_MENU_ALARMS:"Alarmi",
    ASIDE_MENU_FACILITIES:"Perionice",
    ASIDE_MENU_REPORTS:"Izveštaji",
    ASIDE_MENU_REPORT:"Izabrani izveštaj",
    ASIDE_MENU_LOYALTY:"Kampanje",
    ASIDE_MENU_USER_GROUPS:"Grupe korisnika",
    ASIDE_MENU_PERIODIC_SUMMARY:"Periodični pregled",
    ASIDE_MENU_MANAGING_TOKENS:"Upravljanje tokenima",
    ASIDE_MENU_NEWS:"Vesti",
    DAILY_FINANCES_TOTAL_MONEY:"Ukupno novca",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Ukupno novca za sve perionice",
    DAILY_FINANCES_TOTAL_COINS:"Ukupno korišćenih metalnih žetona",
    DAILY_FINANCES_DOWNLOAD_CSV:"Preuzmi CSV",
    DAILY_FINANCES_ONLINE:"Online",
    DAILY_FINANCES_OFFLINE:"Gotovina",
    DAILY_FINANCES_CHANGER:"Gotovina u menjaču",
    DAILY_FINANCES_COINS:"Žetoni",
    REPORTS_FILTER:"Filter",
    REPORTS_TYPE_OF_REPORT:"Tip izveštaja",
    REPORTS_CHOOSE_FACILITY:"Odabir perionice",
    REPORTS_PERIOD_1:"Period 1 -",
    REPORTS_PERIOD_2:"Period 2 -",
    MONEY_BY_DATE_REPORT:"Ukupni prihod po danu",
    R2W_BY_DATE_REPORT:"Ukupno potrošenih R2W žetona po danu",
    COINS_BY_DATE_REPORT:"Ukupno kovanica po danu",
    AVG_MONEY_BY_HOUR_REPORT:"Prosečan prihod po satima",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Prosečan prihod po danima",
    AVG_MONEY_BY_BOX_REPORT:"Potrošnja po boksu",
    COMPARE_PERIODS_REPORT:"Uporedni prikaz po perionici",
    TOTAL_USERS_BY_GROUP:"Ukupno korisnika R2W aplikacije po danu",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"korisnika",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"poseta/e",
    VISITS_COUNT_REPORT:"Broj korisnika R2W aplikacije po dolascima",
    LOYALTY_PER_DAY_REPORT:"Broj potrošenih lokalnih žetona po danu",
    LOYALTY_PER_PAYMENT_METHOD:"Datih lokalnih žetona po načinu plaćanja",
    VISITS:"Posete",
    VISIT:"Poseta",
    TOTAL_SPENT_MONEY:"Ukupno prihoda",
    MONEY:"Novac",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Ukupno potrošenog novca za period",
    DOWNLOAD_CSV:"Preuzmi CSV",
    TOTAL_SPENT_COINS:"Ukupno potrošenih kovanica",
    TOTAL_USERS:"Ukupno korisnika",
    TOTAL_CREDIT_GIVEN:"Ukupno potrošenih lokalnih virtuelnih žetona",
    EUROKEY_BY_DATE_REPORT:"Ukupna plaćanja euro ključa",
    TOTAL_SPENT_EUROKEY:"Ukupno potrošeno",
    SELECT_TYPE_OF_REPORT:"Morate odabrati vrstu izveštaja :)",
    NUMBER_OF_VISITS_TITLE:"Broj poseta",
    NUMBER_OF_USERS_TITLE:"Broj korisnika",
    PIECES_TITLE:"Komada",
    TOTAL_VISITS:"Ukupno poseta",
    TOKENS_TITLE:"tokeni",
    SEARCH_USERS_NO_RESULTS:"Nema korisnika za zadati kriterijum pretrage",
    SEARCH_USERS:"Pretraga korisnika",
    SEARCH_TELEPHONES:"Pretraga po broju mob. telefona",
    ADD_USER_TO_GROUP:"Dodaj korisnika u grupu",
    ADD_USER_BY_ID:"Dodaj korisnika po ID-u",
    REMOVE_USER_FROM_GROUP:"Obriši korisnika iz grupe",
    USER_GROUP_NAME_REQUIRED:"Ime grupe korisnika je obavezno polje.",
    USER_GROUP_NAME:"Ime grupe korisnika",
    USER_GROUP_TYPE:"Tip grupe",
    USER_GROUP_TYPE_DEFAULT:"Podrazumevana",
    USER_GROUP_TYPE_SAVINGS:"Štednja",
    USER_GROUPS_OVERVIEW:"Pregled grupa korisnika",
    USER_COUNT:"Broj korisnika",
    NEW_USER_GROUP:"Kreiraj novu grupu korisnika",
    DELETE_USER_GROUP:"Obriši grupu korisnika",
    UPDATE_USER_GROUP:"Izmeni grupu korisnika",
    DELETE_USER_GROUP_ERROR:"Došlo je do greške prilikom brisanja odabrane korisničke grupe. Molimo Vas pokušajte ponovo ili kontaktirajte tehničku podršku...",
    CONFIRM_DELETE_USER_GROUP:"Da li ste sigurni da želite obrisati odabranu grupu korisnika?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Akcije kojima je grupa bila dodeljena prestaće da važe za korisnike obrisane grupe.",
    GROUP_NAME_MAX_LENGTH:"Ime grupe mora biti manje od 255 karaktera",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Korisnik je već u ovoj grupi",
    MISSING_USER:"Nepoznat korisnik",
    USER_NOT_ON_LIST:"Korisnik nije u aktivnoj listi. Proverite da li je email ispravan i pokušajte ponovo.",
    UPLOAD_USER_GROUP:"Uvezi grupe iz *.csv-a",
    UKNOWN_USERS:"Lista nepoznatih korisnika",
    CAMPAIGN_TEMPLATE_RULE:"Pravilo kampanje",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Došlo je do greške prilikom brisanja odabranog šablona kampanje. Molimo Vas pokušajte ponovo ili kontaktirajte tehničku podršku...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Da li ste sigurni da želite obrisati odabrani šablon kampanje?",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Da li ste sigurni da želite obrisati odabrani šablon kampanje?",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Pregled šablona kampanja",
    DELETE_CAMPAIGN_TEMPLATE:"Obriši šablon kampanje",
    UPDATE_CAMPAIGN_TEMPLATE:"Izmeni šablon kampanje",
    CREATE_CAMPAIGN_TEMPLATE:"Kreiraj novi šablon kampanje",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Ime šablona kampanje je obavezno polje.",
    CAMPAIGN_TEMPLATE_NAME:"Ime šablona kampanje",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Obavezno polje",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"pokloni %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"dodatnog vremena",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Izaberi prvo tip. Perionice ili male mašine.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Obriši pravilo",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Od",
    CAMPAIGN_TEMPLATE_RULE_TO:"do",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"sati",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minuta",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Novo pravilo po broju dolazaka",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Novo pravilo po količini potrošenih žetona",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Novo pravilo po danima u nedelji",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Dodaj novo pravilo",
    CAMPAIGN_TEMPLATE_RULE_1:"Svakih",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Svakih",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"žetona za manje od",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"dolazaka za manje od",
    CAMPAIGN_TEMPLATE_RULE_3:"dana, pokloni",
    CAMPAIGN_TEMPLATE_RULE_4:"žetona",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Lista pravila je prazna.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Datum ne može biti u prošlosti",
    DELETE_CAMPAIGN_ERROR:"Doslo je do greške prilikom brisanja odabrane kampanje. Molimo Vas pokušajte ponovo ili kontaktirajte tehničku podršku...",
    CONFIRM_DELETE_CAMPAIGN:"Da li ste sigurni da želite obrisati odabranu kampanju?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W nije odgovoran za korisničko iskustvo prouzrokovano ovom akcijom.",
    CAMPAIGNS_OVERVIEW:"Pregled kampanja",
    DELETE_CAMPAIGN:"Obriši kampanju",
    UPDATE_CAMPAIGN:"Izmeni kampanju",
    CREATE_CAMPAIGN:"Kreiraj novu kampanju",
    CAMPAIGN_ACTIVE:"Aktivna",
    CAMPAIGN_TEMPLATE:"Šablon",
    CAMPAIGN_GROUPS:"Grupe",
    CAMPAIGN_ALL_USERS:"Svi korisnici",
    CAMPAIGN_NAME:"Ime kampanje",
    CAMPAIGN_NAME_REQUIRED:"Ime kampanje je obavezno polje",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Korisnici blizu limita bonusa po danu",
    MESSAGE_TO_USERS:"Poruka pronađenim korisnicima",
    SEND_MESSAGE:"Pošalji poruku",
    THRESHOLD:"Limit",
    TYPE:"Tip",
    TOTAL_MONEY_SPENT:"Ukupno novca potrošenog u kampanji",
    NUMBER_OF_VISITS:"Ukupno poseta u kampanji",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Poruka mora imati barem 10 karaktera",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Poruka nesme imati više od 350 karaktera",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Tekst poruke je obavezan",
    TECHNOLOGY:"Tehnologija",
    TAP_WATER:"Gradska voda",
    REVERSE_OSMOSIS:"Reverzna osmoza",
    SOFTENED_WATER:"Omekšana voda",
    DOSER:"Dozer",
    STATUS:"Status",
    LAST_SYNCHRONIZATION:"Poslednju sinhronizacija",
    NO_OF_CURRENT_ALARMS:"Vaš broj tekućih alarma",
    NO_OF_CURRENT_WARNINGS:"Broj tekućih upozorenja",
    WEATHER:"Vreme",
    BOXES_WORK_HOURS_COUNTERS:"Brojači sati rada bokseva",
    BOX_TOTAL_HOURS:"Ukupno rada",
    BOX_SERVICE_HOURS:"Ukupno rada (servis)",
    BOX_COUNTER_HOURS:"Sati",
    ALARMS_AND_WARNINGS:"Alarmi i upozorenja",
    FILTER_AND_BOILER:"Filter i bojler",
    FILTER_TOTAL_DAYS:"Dani rada filtera",
    BOILER_TOTAL_DAYS:"Dani rada bojlera",
    DAYS_UNIT:"dana",
    SOFTENER:"Omekšivač",
    MANUAL_COLD_DRAIN:"Ručni zimski ispust",
    EL_COLD:"El. zimski",
    DRAIN:"ispust",
    TAP:"slavina",
    WASTE:"Otpad",
    OSMOSIS:"osmoza",
    DEMI_WATER:"Demi voda",
    EL_RINSE:"El. m. ispiranja",
    BOILER:"Bojler",
    EL_WAX:"El. m. voska",
    FLOOR_HEATING:"Podno grejanje",
    DOSER_TANK:"Kadica dozatora",
    EL_WASH:"El. m. pranja",
    DETERGENT:"Prašak",
    VIBRATOR:"Vibrator",
    UPDATE_FACILITY_SETTINGS:"Izmena postavki perionice",
    GENERAL_SETTINGS:"Opšte postavke",
    LIGHTS:"Svetlo",
    GROUPS:"Grupe",
    ANTI_FREEZE:"Anti smrzavanje",
    AUTO:"Auto",
    MANUAL:"Ručno",
    ON:"Uključeno",
    OFF:"Isključeno",
    TEMPERATURE:"Temperatura",
    UPDATE_DEVICE:"Postavi podešavanja perionice",
    BOX_CLEAN_HOURS:"Brojač sati rada (čišćenje)",
    GROUP_COUNTERS:"Brojači grupa",
    RESET:"Reset",
    CASH_COUNT:"Brojač kovanica",
    COINS_COUNT:"Brojač žetona",
    EUROKEY_COUNT:"Brojač Eurokey",
    DOSER_WORK:"Vreme rada dozera (sec.)",
    DOSER_PAUSE:"Vreme pauze dozera (sec.)",
    DELAY_BFV:"BFV kašnjenje (ms)",
    DELAY_6M1:"6M1 kašnjenje (ms)",
    DELAY_LPS:"LPS kašnjenje (ms)",
    RESET_CASH_COUNT_ALL:"Reset svih brojača kovanica",
    RESET_COINS_COUNT_ALL:"Reset svih brojača žetona",
    RESET_EUROKEY_COUNT_ALL:"Reset svih brojača Eurokey-a",
    FACILITY_DETAILS:"Detalji perionice",
    FACILITY_NAME:"Ime perionice",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Uspešno ste poslali sliku",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Uspešno ste promenili podatke",
    CONNECTED:"Povezan",
    DISCONNECTED:" Disconnected",
    OFFLINE:"Isključen",
    MESSAGES_FILTER:"Filter poruka",
    FACILITY:"Perionica",
    APPLY:"Primeni",
    TIME:"Vreme",
    LOCATION:"Lokacija",
    ACKNOWLEDGED:"Primećena",
    FILTERED_MESSAGES:"Filtrirane poruke",
    ACK:"Primećena",
    NOT_ACK:"Neprimećena",
    ALL:"Svi",
    ALL_FACILITIES:"Sve perionice",
    ENTER_DATE_PLACEHOLDER:"Unesite datum",
    OP_NESTANAK_NAPONA:"Nestanak napona - 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"Pumpa greška MZS",
    OP_UPR_NAPON_24VAC_GRE:"Upravljački napon 24VAC error -5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Zaštita na suvo spremnik pitke vode",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Pumpa pitke vode greška motorna zaštitna sklopka",
    OP_MIN_NIVO_OMEKS_VODE:"Zaštita na suvo spremnik omekšane vode",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Pumpa omekšane vode greška motorske zaštitne sklopke",
    OP_MIN_NIVO_DEMIN_VODE:"Zaštita na suvo spremnik demineralizovane  vode",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Pumpa demineralizovane vode greška motorske zaštitne sklopke",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Pumpa reverzna osmoza greška motorske zaštitne sklopke",
    OP_BOJLER_GRESKA_MZS:"Bojler greška",
    OP_CRPKA_PRASKA_GRE_MZS:"Pumpa praška greška motorske zaštitne sklopke",
    OP_DOZATOR_PRASKA_GRE_MZS:"Dozator praska greška",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Vibrator prska greška",
    OP_MIN_PRASAK_TON_ALARM:"Minimalni nivo spremnik praska",
    OP_USIS_KOV_TURBINA_GRESKA:"Usis kovanica turbina greška motorske zaštitne sklopke",
    OP_FILTER_VODE_ZACEPLJEN:"Filter vode začepljen",
    OP_VISKTL_RESET_SATI_RADA:"Pumpa visokog pritiska servis",
    OPW_VISKTL_RESET_SATI_RADA:" High pressure pump service",
    OP_FILTER_DANI_RADA:"Filter servis",
    OP_BOJLER_DANI_RADA:"Bojler servis",
    OPW_ALARM_VISOKOTL_PUMPA:"Alarm pumpe visokog pritiska",
    OPW_ALARM_FILTER_SERVIS:"Filter servis alarm",
    OPW_ALARM_BOJLER_SERVIS:"Bojler servis alarm",
    HAS_MEMBERS:"Izabrana grupa ima članove i ne može biti izbrisana. Prvo morate izbrisati članove.",
    PERIODIC_SUMMARY_FOR:"PERIODIČNI SUMARNI IZVEŠTAJ ZA",
    PERIODIC_SUMMARY_REPORTS:"Periodični sumarni izveštaji",
    DATE_RANGE:"Vremenski period",
    FINANCIAL_REPORT:"Finansijski izveštaj",
    GROSS_INCOME:"Ukupan prihod",
    GROSS_INCOME_SUM:"Suma ukupnog prihoda",
    COMMISSION_FEE:"Provizije",
    NET_INCOME:"Neto prihod (za naplatu)",
    COMMISSION_FEE_DETAILS:"Uključuju bankovne / PayPal provizije na transakcije ili SMS servis provizije.",
    LOYALTY_CREDITS_REPORT:"Lokalni žetoni",
    LOYALTY_GIVEN:"Poklonjeni lokalni žetoni",
    LOYALTY_USED:"Iskorišteni lokalni žetoni",
    LOYALTY_SOLD:"Učitani lokalni žetoni",
    LOYALTY_TOTAL:"Total",
    LOYALTY_CURRENT_MONTH:"Tekući mesec",
    SOMETHING_WENT_WRONG:"Uuuuuuuuuuups, desila se greška :-(",
    MISSING_PAGE:"Izvinite, nismo u mogućnosti da nađemo datu stranicu",
    TRY_AGAIN:"Pokušajte ponovo",
    DEFAULT_ERROR_NAME:"Nepoznata greška se desila",
    DEFAULT_ERROR_DESCRIPTION:"Molimo pokušajte ponovo, ako problem i dalje postoji kontaktirajte ovlašćeno lice",
    MY_ACCOUNT_DETAILS:"Detalji korisničkog naloga",
    SAVE_CHANGES:"Sačuvaj promene",
    USERNAME:"Korisničko ime",
    FIRST_NAME:"Ime",
    LAST_NAME:"Prezime",
    USER_ROLE:"Korisnička grupa",
    OLD_PASSWORD:"Stara sifra",
    NEW_PASSWORD:"Nova sifra",
    OLD_PASSWORD_REQUIRED:"Stara šifra polje je obavezno",
    NEW_PASSWORD_REQUIRED:"Nova šifra polje je obavezno",
    NEW_PASSWORD_REPEAT:"Ponoviti novu šifru polje je obavezno",
    NEW_PASSWORD_NOT_MATCH:"Stara i nova šifra nisu identične",
    PASSWORD_DIFFERENT_VALIDATION:"Nova lozinka mora biti drugačija od stare",
    PASSWORD_MIN_CHAR:"Vasa lozinka mora imati barem 8 karaktera",
    PASSWORD_MAX_CHAR:"Vasa lozinka mora imati do 32 karaktera",
    PASSWORD_PATTERN_VALIDATION:"Lozinka mora sadržati barem jedan broj, jedno malo i jedno veliko slovo",
    ACCOUNT_MANAGEMENT:"Upravljanje Korisnicima",
    NOT_ACTIVE:"Neaktivan",
    ASSIGN_ROLE:"Korisnička grupa",
    UPDATE:"Ažuriraj",
    ADD_NEW_ACCOUNT:"Dodavanje novog korisnika",
    EMAIL_REQUIRED:"E-mail adresa je obavezna",
    EMAIL_NOT_VALID:"E-mail adresa nije validna",
    ADD_NEW_USER_TEXT:"E-mail sa aktivacionim linkom biće poslat na upisanu adresu",
    UPDATE_USER_NOTIFICATION:"Uspešno ste ažurirali podatke",
    CHANGED_PASSWORD_NOTIFICATION:"Uspešno ste promenili lozinku",
    UPDATE_USER_GROUP_NOTIFICATION:"Uspešno ste promenili ime grupe",
    CREATE_USER_GROUP_NOTIFICATION:"Uspešno ste kreirali grupu",
    DETELE_USER_GROUP_NOTIFICATION:"Uspešno ste obrisali grupu",
    EMPTY_GROUP_LIST_MSG:"Nema kreiranih grupa. Za početak, napravite jednu",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Uspešno ste obrisali korisnika iz grupe",
    ADD_USER_TO_GROUP_NOTIFICATION:"Uspešno ste dodali korisnika u grupu",
    ADD_USER_NOTIFICATION:"Uspešno ste dodali novog korisnika",
    DELETE_USER_NOTIFICATION:"Uspešno ste obrisali korisnika",
    RESEND_USER_VERIFICATION_EMAIL:"Uspešno ste ponovo poslali verifikacioni email",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Da bi ste kreirali grupu korisnika, molimo Vas unesite naziv grupe.",
    DELETE_USER:"Brisanje korisnika",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Da li ste sigurni da želite obrisati korisnika iz grupe?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Poštovani, ukoliko nas posetite tokom akcije ovog meseca dobićete dodatni bonus na vaš račun.",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Pravilo kampanje po broju dolazaka",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Pravilo kampanje po potrošenim žetonima",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Pravilo kampanje po danima u nedelji",
    REMOVE_CAMPAIGN_RULE_TITLE:"Brisanje pravila kampanje",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Da li ste sigurni da želite da obrišete pravilo kampanje?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Uspešno ste sačuvali novo pravilo kampanje",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Uspešno ste aktivirali kampanju",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Nema kreiranih kampanja. Za početak, napravite jednu",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Uspešno ste poslali poruku",
    COMPANY_ACCOUNTS:"Kompanijski nalozi",
    BUSSINESS_INVOICES_LIST:"Moje B2B fakture",
    LOCALE_TOKEN:"Lokalni token",
    R2W:"Globalni token",
    START_MONTH:"Početni mesec",
    END_MONTH:"Krajnji mesec",
    TOKEN_TYPE:"Tip tokena",
    TOKEN_NUMBER:"Broj tokena",
    NOTHING_TO_DISPLAY:"* Nema podataka za prikaz",
    CREATE_INVOICE:"Nova Faktura",
    INVOICE:"Faktura",
    INVOICES:"Fakture",
    EDIT_INVOICE:"Promeni Fakturu",
    UPDATE_INVOICE_NOTIFICATION:"Uspešno ste promenili status fakture u 'u izvršenju'",
    CURRENT_CHARGES:"Zaduženje za tekući period",
    PAYMENTS_ON_HOLD:"Poslati računi",
    FOR_INVOICING:"Nije fakturisano",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Pokušavate da poništite fakturu",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Da li ste sigurni da želite da poništite fakturu?",
    INVOICING_NOTIFICATION_HEADER:"Pokušavate da pošaljete fakturu",
    INVOICING_NOTIFICATION_TEXT:"Da li ste sigurni da želite da pošaljete fakturu?",
    SENT_INVOICE_NOTIFICATION:"Uspešno ste poslali fakturu",
    CANCELED_INVOICE_NOTIFICATION:"Uspešno ste poništili fakturu",
    INVOICE_DESCRIPTION_TEXT:"Faktura za mesec",
    INVOICE_STATE:"Status fakture",
    INVOICE_NUMBER:"Broj fakture",
    INVOICE_TOTAL:"Ukupno",
    SELECT_YEAR:"Izaberi godinu",
    DOWNLOAD:"Skini PDF",
    INVOICE_NUMBER_HEADER:"Nameravate da pošaljete fakturu sa brojem",
    INVOICE_PAYMENT_CONFIRMATION:"Nameravate da potvrdite plaćanje fakture sa brojem",
    INSERT_INVOICE_NUMBER:"Unesi broj fakture",
    INVOICED_WARNING:"Email nije poslat. Molim Vas sačekajte ...",
    SEND_INVOICE:"Pošalji",
    INVOICE_ALL:"Sve",
    INVOICE_FROM_R2W:"Od R2W",
    INVOICE_TO_R2W:"Za R2W",
    PAYMENT_REQUEST:"Zahtev za plaćanje",
    PAYMENT_REQUEST_STATE:"Zahtev za plaćanje",
    PAYMENT_REQUEST_NUMBER:"Broj zahteva za plaćanje",
    FOR_PAYMENT_REQUEST:"Za zahtev za plaćanje",
    PAYMENT_REQUEST_ON_HOLD:"Zahtev za plaćanje u obradi",
    DOWNLOAD_INVOICE:"Preuzimanje faktura",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Kliknite na opcije za preuzimanje",
    B2B_SPEC:"B2B Specifikacija",
    B2C_SPEC:"B2C Specifikacija",
    DOWNLOAD_PAYMENT_REQUEST:"Preuzmi zahtev za plaćanje",
    LOYALTY_PREVIEW:"Pregled kampanje",
    ACTIVATED:"Aktivna",
    RUNNING:"Traje",
    NOT_ACTIVATED:"Nije aktivna",
    FINISHED:"Završena",
    DEPRECATED:"Zastarela",
    UPCOMING:"Nadolazeća",
    NONE:"Niko",
    STARTED:"Počela",
    ENDS:"Završava se",
    DEDICATED:"Dodeljena",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Pokušavate da aktivirate",
    CAMPAIGN:"kampanju",
    SEND_MESSAGE_NOTIFICATION:"Da želite da pošaljete poruku svim korisničkim grupama",
    DIVISIBLE_TO_NUMBER:"Broj bi trebao biti deljiv sa ",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Tip uređaja",
    LISTENER:"Male mašine",
    BRIDGE:"Boks za pranje",
    WASH_BOXES:"Boks za pranje",
    VACUUMS:"Usisivači",
    SAVE_NEWS:"Sačuvaj vest",
    CREATE_NEW_NEWS:"Kreiraj novu vest",
    HISTORY_OF_ALL_NEWS:"Istorija svih vesti",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Upiši ime perionice",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Dodaj novu perionicu",
    NEWS_TEXT:"Tekst vesti",
    NEWS_TITLE:"Naslov vesti",
    DELETE_NEWS_CONFIRMATION:"želite da obrišete vest ?",
    NEWS_DELETE_NOTIFICATION:"Uspešno ste obrisali vest",
    NEWS_SAVE_NOTIFICATION:"Uspešno ste sačuvali vest",
    NEWS_CREATION_DATE:"Datum kreiranja",
    NO_TITLE:"Nema naslova",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Tekst vesti nesme biti duži od 255 karaktera",
    NEWS_TEXT_REQUIRED_VALIDATION:"Tekst vesti je obavezan",
    NEWS_TITLE_REQUIRED_VALIDATION:"Naslov vesti je obavezan",
    DEACTIVATE:"Deaktiviraj",
    ASIDE_MENU_LOCAL_TOKENS:"Lokalni žetoni",
    CREATE_NEW_LOCAL_TOKENS:"Izdavanje novih lokalnih žetona",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Unesite email adresu korisnika i broj žetona koje želite da mu izdate",
    CREATE_TOKENS:"Izdaj žetone",
    MINIMUM_ONE_TOKEN:"Vrednost mora biti veća od 0",
    CUSTOMER_EMAIL:"Korisnikova email adresa",
    AMOUNT_OF_TOKENS:"Broj žetona",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Uspešno ste izdali lokalne žetone na",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Desila se greška prilikom izdavanja žetone. Molimo Vas proverite korisnikovu email adresu i pokušajte ponovo.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Pregled izdatih lokalnih žetona",
    ISSUED_AT:"Vreme izdavanja",
    ISSUED_BY:"Izdato od",
    CODE:"Kod",
    REDEEMED_BY:"Iskorišćeno od",
    REDEEMED_AT:"Vreme",
    ASIDE_MENU_VOUCHERS:"Vaučeri",
    PRINT:"Štampa",
    VOUCHERS_OVERVIEW:"Pregled vaučera",
    CREATE_NEW_VOUCHERS:"Kreiranje novih vaučera",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Kreirajte novu seriju vaučera unošenjem broja žetona po vaučeru, količine vaučera u seriji i prefiks koda za seriju",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Broj žetona po vaučeru",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Dozvoljeno je dodeliti između 1 i 100 žetona po vaučeru",
    NUMBER_OF_NEW_VOUCHERS:"Količina vaučera u seriji",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Dozvoljeno je kreiranje između 1 i {{size}} vaučera u jednoj seriji",
    NEW_VOUCHERS_PREFIX:"Prefiks kod vaučera u seriji",
    VALIDATION_VOUCHER_PREFIX:"Prefiks kod mora sadržati tačno 4 heksadecimalna karaktera (0-9, A-F)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Desio se problem prilikom kreiranja novih vaučera. Molimo Vas pokušajte ponovo ili kotaktirajte sistemsku podršku.",
    CREATE_VOUCHERS:"Kreiraj seriju vaučera",
    CREATING_VOUCHERS_SUCCESS:"Nova serija vaučera kreirana uspešno",
    PRINT_NEW_VOUCHERS:"Štampaj vaučere",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Unesite broj serije vaučera, ceo kod ili deo koda vaučera, kako bi ste odštampali odgovarajuće vaučere.",
    PRINT_VOUCHERS_PREFIX:"Prefiks kod (serija) vaučera",
    NO_VOUCHERS_FOR_PRINT:"Nema vaučera za štampu sa unetim prefix kodom",
    PRINT_VOUCHERS:"Štampaj vaučere",
    VALIDATION_VOUCHER_CODE_FILTER:"Prefiks kod filter može sadržati između 1 i 16 karaktera, i podržava samo velika slova i brojeve.",
    FILTER_VOUCHERS_BY_CODE:"Filter vaučera po kodu",
    FILTER_VOUCHERS:"Filter",
    WASH_BOX:"Perionica",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Ukupno korišćenih digitalnih žetona",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Ukupno kupljenih lokalnih virtuelnih žetona po danima",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Ukupno potrošenih lokalnih virtuelnih žetona po danu",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Ukupno poklonjenih lokalnih virtuelnih žetona po danu",
    LOCAL_TOKEN:"Lokalni žeton ",
    GIVEN_TOKEN:"Poklonjeni žetoni",
    SOLD_TOKEN:"Prodati žetoni",
    SMALL_MACHINES:"Male mašine",
    R2W_Listener:"Listener",
    HHANLE_DEVICE:"HHanle - Perionica",
    CODE_PREFIX_EXIST:"Code prefix već postoji",
    CODE_PREFIX_EXIST_TEXT:"Ne možete kreirati novi voucher sa ovim code prefix-om. Definišite novi.",
    INVALID_PREFIX:"Neispravan prefiks",
    INVALID_HEX_PREFIX_TEXT:"Prefiks mora sadržati samo heksadecimalne karaktere (0-9, A-F).",
    MIN_FOUR_VALIDATION:"Tačno 4 karaktera",
    ALL_INFORMATION_1:"Sve informacije o",
    ALL_INFORMATION_2:"će biti izgubljene",
    ASIDE_MENU_TRANSACTIONS:"Transakcije",
    EXPENSES:"Troškovi",
    TOPUPS:"Kupljeni tokeni",
    EXPENSES_LIST:"Lista troškova",
    USER_EMAIL:"Korisnički email",
    COMPANY_NAME:"Naziv kompanije",
    TOPUPS_LIST:"Lista kupljenih tokena",
    CONSUMER:"Consumer",
    SYSTEM_ADMIN:"System administrator",
    MERCHANT_ADMIN:"Merchant administrator",
    COMPANY_ADMIN:"Company administrator",
    FACILITY_ADMIN:"Facility administator",
    SUBSCRIBER:"Subscriber",
    CONFIGURATOR:"Configurator",
    SETUP_UNIT_SERIAL_NO:"Serijski broj",
    SETUP_UNIT_MATERIAL_NO:"Materijalni broj",
    SETUP_UNIT_WEBAPI_VERSION:"Verzija WebApi - ja",
    TOTAL_TURNOVER:"Promet na perionici",
    AVAILABILITY_ALL:"Dostupnost",
    AVAILIBILITY:"Dostupnost boksova za pranje",
    AVAILABILITY_VACUUMS:"Dostupnost usisivača",
    WASH_BOX_INFO:"Info boksova za pranje",
    VACUUM_CLEANER_INFO:"Info usisivača",
    BREAD_CRUMBS_SERVICE:"Servis",
    HOLIDAYS:"Praznici",
    HOLIDAY:"Praznik",
    LIGHTS_ON:"Svetlo/uključi",
    LIGHTS_OFF:"Svetlo/isključi",
    WASH_BOXES_ON:"Boks za pranje/uključi",
    WASH_BOXES_OFF:"Boks za pranje/isključi",
    VACUUMS_ON:"Usisivač/uključi",
    VACUUMS_OFF:"Usisivač/isključi",
    TURNOVER:"Promet",
    TURNOVER_MANUAL_WASH_UNIT:"Promet priručnik",
    STATUS_BAY_RUN_TIME:"Ukupno vreme rada boksa za pranje",
    STATUS_BAY_PROGRAM_NAME:"Ime programa",
    STATUS_BAY_CREDIT:"Kredit boksa za pranje",
    CLOUD_KREDIT:"Kredit klauda",
    STATUS_VACUUM_RUN_TIME:"Ukupno vreme rada usisivača",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Servis perionice, programi boksova za pranje i informacije o trenutnim greškama",
    UNAVAILABLE:"Uređaj je nedostupan",
    SHOW_HIDE_TABLE:"Sakrij/prikaži tabelu radnih sati",
    PROGRAM_NAME:"Ime programa",
    PROGRAM_OPTION:"Opcija programa",
    DEVICE:"Uređaj",
    QUANTITY:"Količina",
    PROGRAM_COUNTER:"Brojač programa",
    NO_NAME:"Referenca nema naziv",
    COUNTER_SERVICE_DATA:"Servisni podaci",
    NEED_SERVICE:"Potreban servis",
    PROGRAM_DATA:"Podaci o boksovima za pranje",
    CURRENT_FAULT_DATA:"Trenutne greške",
    REFERENCE_DUE:"Dospelo",
    REFERENCE_SECONDS:"Sekunde",
    REFERENCE_NAME:"Naziv dela",
    WASHBOX_NAME:"Ime boksa za pranje",
    FAULT_NAME:"Ime greške",
    FAULT_NUMBER:"Broj greške",
    CURRENT_FAULT_COUNT:"Aktivne greške",
    DEVICE_NOT_INSTALLED:"Uređaj nije instaliran",
    STATUS_READY:"Spreman",
    STATUS_ERROR:"Greška",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:"Softverska greška",
    SOFTWARE_RESET:"Softverska greška",
    EXTERNAL_PIN_RESET:"Softverska greška",
    RESTART_OR_BROWNOUT_OCCURRED:"Softverska greška",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Hardverska greška",
    COULD_NOT_SIMULATE_COIN:"Hardverska greška",
    ERROR_SETTING_INHIBIT_MODE:"Hardverska greška",
    OFFLINE_DEVICE:"Offline autoperionica",
    TARIFFS:"Tarife",
    DAY:"Dan",
    NIGHT:"Noć",
    VOUCHER_CODE:"Kod vaučera",
    DISMISS_ALARM:"Resetujte alarm?",
    ALARM_ACTIVE:"Aktivni alarmi",
    NO_ALARM_ACTIVE:"Nema aktivnih alarma",
    ALARM_HISTORY:"Istorija alarma",
    MANAGING_TOKENS:"Upravljanje lokalnim žetonima",
    EXPIRATION_DATE:"Datum isteka",
    EXTEND_TOKEN_DATE:"Produži datum isteka žetona za",
    DELETE_TOKENS_FOR:"Obriši lokalne digitalne žetone za",
    PUMP_TYPE:"Tip pumpe",
    TURN_OFF_DEVICE:"Status uređaja",
    OPERATION_DATA:"Operativni podaci",
    PUMP_DATA:"Podaci pumpe",
    PUMP_NAME:"Naziv pumpe",
    POINT_NAME:"Naziv tačke",
    CHANGER_INCOME:"Ukupan prihod menjača po datumu",
    SELECTED_OPEN:"Otvoreno u odabrano radno vreme",
    ALWAYS_OPEN:"Uvek otvoreno (24/7)",
    CLOSED:"Zatvoreno",
    CLOSED_24:"Zatvoreno 24h",
    OPENED_24:"Otvoreno 24h",
    DAY_STATE:"Ceo dan",
    MON:"Ponedeljak",
    TUE:"Utorak",
    WED:"Sreda",
    THU:"Četvrtak",
    FRI:"Petak",
    SAT:"Subota",
    SUN:"Nedelja",
    PRICING:"Cenovnik",
    PRICE:"Cena",
    SO_PRICE:"SO Cena",
    VALIDITY:"Validnost",
    TOKEN_PACKAGES:"Paketi žetona",
    SINGLE_WASH:"Jedno pranje",
    FACILITY_WORKING_HOURS:"Postavite radno vreme za izabrani objekat",
    WORKING_HOURS_ALWAYS_OPEN:"Uvek otvoreno",
    WORKING_HOURS_ALWAYS_CLOSE:"Zatvoreno od strane operatera",
    WORKING_HOURS_CUSTOM:"Postavite radno vreme",
    KARCHER_ERROR_CODE:"Kod greške upozorenja",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor BUFFER TANK EMPTY activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor BUFFER CONTAINER EMPTY and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor RO PUMP ON and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:"Organizacija",
    CREATE_ORGANIZATION:"Kreiraj organizaciju",
    CREATE_ORGANIZATION_AS:"Kreiraj organizaciju kao podobjekat za",
    DELETE_ORGANIZATION:"Obriši organizaciju",
    EDIT_ORGANIZATION:"Uredi organizaciju",
    SUPPORTED_ORG_NAME:"Podržana organizacija",
    SUPPORTED_ORG_TYPE:"Podržani tip",
    ORG_NAME:"Ime",
    ORG_TYPE:"Tip",
    SET_ORG_TITLE:"Postavi podorganizaciju",
    SET_SUPPORTED_ORG_TITLE:"Postavi podržanu podorganizaciju",
    SAVE_ORGANIZATION:"Sačuvaj organizaciju",
    SELECT_ORGANIZATION_TYPE:"Izaberi tip organizacije",
    SELECT_ORGANIZATION_SELECTOR:"Izaberi",
    SELECT_SUPPORTED_ORGANIZATION:"Izaberi podržanu organizaciju",
    ORGANIZATION_DELETED:"Organizacija uspešno obrisana",
    ORGANIZATION_SAVED:"Organizacija uspešno sačuvana",
    ORGANIZATION_UPDATED:"Organizacija uspešno ažurirana",
    ALERTS:"Upozorenja",
    DEVICE_STATUS:"Status uređaja",
    SITE_DETAILS:"Detalji autoperionice",
    ALARM_STATUS:"Status upozorenja",
    FILTER:"Filtriraj po ...",
    FILTER_BY_ALERT_CENTER:"Filtriraj po kodu, imenu ili opisu",
    TOTAL_ALARM:"Ukupno",
    LOW_ALARM:"Događaj",
    MEDIUM_ALARM:"Kvar",
    HIGH_ALARM:"Kritična greška",
    NO_FACILITIES_NEARBY:"Nema obližnjih objekata",
    GRAY_MAP:"Siva mapa",
    READY:"Spreman",
    WARNING:"Kvar",
    ERROR:"Greška",
    SITE_NAME:"Ime autoperionice",
    ACCOUNTS_INFO:"Informacije o nalogu",
    USER_ORGANIZATION:"Organizacija korisnika",
    ADD_USER_ORGANIZATION:"Dodaj novog korisnika organizacije",
    EDIT_USER_ORGANIZATION:"Uredi korisnike organizacije",
    SELECT_ROLE:"Izaberi ulogu",
    SELECT_ORGANIZATION:"Izaberi organizaciju",
    SELECT_USER:"Izaberi  korisnika",
    USER_FOR_ORGANIZATION_CREATED:"Novi korisnik uspešno kreiran",
    SELECT_REGION:"Izaberi region",
    SELECT_LANGUAGE:"Izaberi jezik",
    LOADING_DATA:"Učitavanje podataka, molimo sačekajte...",
    ADMINISTRATOR:"Administrator",
    TECHNICAL_SUPPORT:"Tehnička podrška",
    CASHIER:"Kasir",
    CONTROLLER:"Kontroler",
    EDIT_ORGANIZATION_USER:"Uredi korisnike organizacije",
    DELETE_ORGANIZATION_USER:"Obriši korisnike organizacije",
    USER_UPDATED:"Korisnik uspešno ažuriran",
    USER_CREATED:"Korisnik uspešno kreiran",
    ADDRESS:"Adresa",
    SUBSCRIPTIONS:"Pretplate",
    RESOLVED_STATUS:"Rešeno",
    NOT_RESOLVED_STATUS:"Nije rešeno",
    ALERT_NAME:"Naziv upozorenja",
    ALERT_DESCRIPTION:"Opis upozorenja",
    ALERT_CODE:"Kod upozorenja",
    ALERT_TYPE:"Tip upozorenja",
    UNSUBSCRIBE:"Odjavi se sa upozorenja",
    SUBSCRIBE:"Prijavi se na upozorenje",
    ALARM_SUBSCRIBED:"Uspešno prijavljeno",
    UNSUBSCRIBED_CONFIRM:"Odjavi se?",
    ALARM_UNSUBSCRIBED:"Uspešno odjavljeno",
    ASIDE_MENU_CASHLESS_SALES:"Bezgotovinska prodaja",
    FILTERED_CASHLESS_PAYMENTS:"Filtrirane bezgotovinske uplate",
    REFUND_DIALOG_TITLE:"Povrat transakcije?",
    REFUND_DIALOG_SUBTITLE:"Iznos može biti manji ili jednak iznosu transakcije",
    REFUND:"Povrat",
    INPUT_NOT_VALID:"Unos nije validan",
    REFUND_SUCCESSFULLY:"Povrat za izabranu uplatu uspešno izvršen",
    CARD_LAST_DIGITS:"Poslednje cifre kartice",
    PAYMENT_BRAND:"Brend plaćanja",
    REFUNDED_AMOUNT:"Vraćeni iznos",
    MERCHANT_REFUND_SPLIT:"Merchant deo povrata",
    USER:"Korisnik",
    TRANSACTION_ID:"PSP referenca",
    DEVICE_ID:"ID uređaja",
    NET_AMOUNT:"Neto iznos",
    TRANSACTION_STATUS:"Status transakcije",
    REPORT_NAME:"Naziv izveštaja",
    TIME_FRAME:"Vremenski okvir",
    SUB_POINT:"Izaberi pod-tačku",
    SUB_POINT_LIST_NOT_EXIST:"Spisak pod-tačaka ne postoji za izabrani objekat za pranje",
    FACILITY_TYPE:"Tip autoperionice",
    MACHINE_NAME:"Naziv mašine",
    WASH_FACILITY_DETAILS:"Detalji mašina na autoperionici",
    WASH_BAY_DETAILS:"Detalji bokseva za pranje",
    DEVICES_INFO:"Spisak uređaja",
    OPERATION_TIME_INFO:"Vreme rada",
    OPERATION_TIME_VACUUM_INFO:"Vreme rada usisivača",
    OPERATION_TIME_ILLUMINATION_INFO:"Vreme rada osvetljenja",
    AVAILABLE_TITLE:"Dostupno",
    UNAVAILABLE_TITLE:" Nedostupno",
    CURRENT_PROGRAM:"Trenutni program",
    CREDITS:"Krediti",
    DEVICE_NAME:"Naziv uređaja",
    ACTIVE_ALARMS:"Aktivna upozorenja",
    ALL_DAY:"Ceo dan",
    OPERATING_TIME_WASH_FACILITY:"Sistem za samouslužno pranje",
    OPERATING_TIME_VACUUMS:"Usisivači",
    OPERATING_TIME_ILLUMINATION:"Osvetljenje",
    OPERATION_COUNTERS:"Brojači operacija",
    EDIT:"Uredi",
    WASHING_PROGRAMS:"Programi pranja",
    INFO:"Događaj",
    STATISTIC:"Statistika",
    ROLLOVER_DOSING:"Doziranje",
    ROLLOVER_SPEED:"Brzine",
    ROLLOVER_RESETS:"Daljinsko resetovanje rollover-a",
    ROLLOVER_RESETS_INFO:"Daljinsko resetovanje mora biti u skladu sa lokalnim propisima. Važno: Pre resetovanja, uverite se da je rollover prazan.",
    RESET_ROLLOVER:"Resetuj rollover",
    OPEN_DOOR_ROLLOVER:"Otvori",
    ROLLOVER_OPEN_DOOR_INFO:"Otvori vrata za pranje. Budite oprezni.",
    ROLLOVER_OPEN_DOOR:"Otvori vrata",
    APPLY_DOSING_CHANGES:"Primeni promene doziranja",
    APPLY_SPEED_CHANGES:"Primeni promene brzina",
    ACTUATION_SUCCESS:"Zahtev poslat",
    REMAINING_TIME:"Preostalo vreme",
    OPEN_24H:"Otvoreno 24 sata",
    CLOSE_24H:"Zatvoreno 24 sata",
    VALIDATION_OPERATION_TIME:"Format nije tačan. Koristite hh",
    ROLLOVER:"Rollover",
    UPDATE_WASHING_PROGRAM:"Ažuriraj program pranja",
    UPDATE_ACTUATORS:"Ažuriraj aktuatore",
    OPEN_ROLOVER_DOOR_TITLE:"Želite li otvoriti vrata rollover-a?",
    OPEN_ROLOVER_DOOR_CONTENT:"Da li ste sigurni da želite otvoriti vrata?",
    RESET_ROLOVER_TITLE:"Želite li resetovati rollover?",
    RESET_ROLOVER_CONTENT:"Da li ste sigurni da želite resetovati rollover?Da li ste sigurni da želite resetovati rollover?",
    G0:"{{brand === 'r2w' ? 'Boks 0' : 'Boks 1'}}",
    G1:"{{brand === 'r2w' ? 'Boks 1' : 'Boks 2'}}",
    G2:"{{brand === 'r2w' ? 'Boks 2' : 'Boks 3'}}",
    G3:"{{brand === 'r2w' ? 'Boks 3' : 'Boks 4'}}",
    G4:"{{brand === 'r2w' ? 'Boks 4' : 'Boks 5'}}",
    G5:"{{brand === 'r2w' ? 'Boks 5' : 'Boks 6'}}",
    G6:"{{brand === 'r2w' ? 'Boks 6' : 'Boks 7'}}",
    G7:"{{brand === 'r2w' ? 'Boks 7' : 'Boks 8'}}",
    G8:"{{brand === 'r2w' ? 'Boks 8' : 'Boks 9'}}",
    G9:"{{brand === 'r2w' ? 'Boks 9' : 'Boks 10'}}",
    G10:"{{brand === 'r2w' ? 'Boks 10' : 'Boks 11'}}",
    U0:"{{brand === 'r2w' ? 'Usisivač 0' : 'Usisivač 1'}}",
    U1:"{{brand === 'r2w' ? 'Usisivač 1' : 'Usisivač 2'}}",
    U2:"{{brand === 'r2w' ? 'Usisivač 2' : 'Usisivač 3'}}",
    U3:"{{brand === 'r2w' ? 'Usisivač 3' : 'Usisivač 4'}}",
    U4:"{{brand === 'r2w' ? 'Usisivač 4' : 'Usisivač 5'}}",
    U5:"{{brand === 'r2w' ? 'Usisivač 5' : 'Usisivač 6'}}",
    U6:"{{brand === 'r2w' ? 'Usisivač 6' : 'Usisivač 7'}}",
    U7:"{{brand === 'r2w' ? 'Usisivač 7' : 'Usisivač 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Alert centar izveštaj kreiran odabrane lokacije sa kontrolne table",
    ALERT_CENTER_TITLE_BY_FACILITY:"Alert centar izveštaj kreiran odabrane objekta sa kontrolne table",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Alert centar izveštaj",
    ERROR_MESSAGE_403:"Nemate privilegiju da koristite ovaj API poziv. Greška kod: 403",
    LAST_ACTIVE_PROGRAM:"Aktivan program / Poslednji aktivan program",
    PROGRAM_ID:"Broj programa",
    PROGRAM_PRICE:"Cena programa",
    PROGRAM_SO_PRICE:"SO Cena",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Potrebno je dopuniti",
    EMPTY_CHEMICAL_LEVEL:"Prazno",
    CHEMICAL_LEVEL:"Indikacija nivoa deterdženata (%)",
    ROLLOVER_STATUS:"Status četki",
    ROLLOVER_STATUS_CODE_0:"Perionica trenutno van funkcije",
    ROLLOVER_STATUS_CODE_1:"Van radnog vremena",
    ROLLOVER_STATUS_CODE_2:"Dozvoljen ulazak u program",
    ROLLOVER_STATUS_CODE_3:"Pozicionirajte vozilo",
    ROLLOVER_STATUS_CODE_4:"Vozilo napred",
    ROLLOVER_STATUS_CODE_5:"Vozilo nazad",
    ROLLOVER_STATUS_CODE_6:"Vozilo stani",
    ROLLOVER_STATUS_CODE_7:"Pranje aktivno",
    ROLLOVER_STATUS_CODE_8:"Pranje zaustavljeno",
    ROLLOVER_STATUS_CODE_9:"Pranje aktivno (takt)",
    ROLLOVER_STATUS_CODE_10:"Izlazak vozila nazad",
    ROLLOVER_STATUS_CODE_11:"Hitno zaustavljanje",
    ROLLOVER_STATUS_CODE_12:"Izlazak vozila napred",
    ROLLOVER_STATUS_CODE_13:"Aktivno protiv smrzavanja",
    ROLLOVER_STATUS_CODE_14:"Aktiviran sigurnosni prekidač napred",
    ROLLOVER_STATUS_CODE_15:"Aktiviran sigurnosni prekidač nazad",
    ROLLOVER_STATUS_CODE_16:"Aktiviran sigurnosni prekidač levo napred",
    ROLLOVER_STATUS_CODE_17:"Aktiviran sigurnosni prekidač desno napred",
    ROLLOVER_STATUS_CODE_18:"Aktiviran sigurnosni prekidač levo nazad",
    ROLLOVER_STATUS_CODE_19:"Aktiviran sigurnosni prekidač desno nazad",
    ROLLOVER_STATUS_CODE_20:"Vozilo je previše levo",
    ROLLOVER_STATUS_CODE_21:"Vozilo je previše desno",
    ROLLOVER_STATUS_CODE_22:"Leva vrata nisu zatvorena",
    ROLLOVER_STATUS_CODE_23:"Desna vrata nisu zatvorena",
    ROLLOVER_STATUS_CODE_24:"Detektovan transporter, izabran je pogrešan program pranja",
    ROLLOVER_STATUS_CODE_25:"Senzor sirene",
    ROLLOVER_STATUS_CODE_98:"Ručni / podešavajući režim",
    ROLLOVER_STATUS_CODE_99:"Nepoznat status",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Statusni kod nije definisan",
    ALARM:"Kritična greška",
    NO_ALARM:"Nema kritične greške",
    SOFTWARE_VERSION:"Verzija softvera",
    SOFTWARE_DATE:"Datum softvera",
    SITE_ADDRESS:"Adresa lokacije",
    SECONDS:"Sekunde",
    SERVICE_PART_NAME:"Naziv usluge:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Brojač operacija i servisiranja",
    OPERATION_COUNTER:"Brojač operacija",
    SERVICE_COUNTER:"Brojač servisiranja",
    FAULT_CODE:"Kod upozorenja",
    PRESSURE_TITLE:"Pritisak vazduha",
    TIME_TITLE:"Trenutno vreme",
    COUNTRY_TITLE:"Država",
    CITY_TITLE:"Grad",
    REGION_TITLE:"Region",
    SELECT_POINTS_TO_SEARCH:"Izaberi tačke ...",
    LOGS_HISTORY:"Istorija promena parametara",
    ACTUATOR_REFERENCE:"Referenca aktuatora",
    ACTUATOR_VALUE:"Vrednost aktuatora",
    POINT_ID:"ID tačke",
    VALIDATION_NOT_VALID_RANGE:"Pogrešan opseg",
    ENABLE_ROLLOVER_RESET:"Označavanjem ovog polja potvrđujete da ste pročitali i slažete se sa sigurnosnim uputstvima",
    CHANGE_OF_PARAMETERS:"Promena parametara",
    SELECT_OPTIONS:"Izaberi opcije",
    AUTOMATIC:"Automatski",
    DESALTING:"Funkcija odstranjivanja soli",
    SEASON_WASH:"Programi pranja po godišnjim dobima",
    SPRING_PROGRAM:"Programi pranja za proleće",
    SUMMER_PROGRAM:"Programi pranja za leto",
    AUTUMN_PROGRAM:"Programi pranja za jesen",
    WINTER_PROGRAM:"Programi pranja za zimu",
    DOOR_CONTROL:"Kontrola vrata",
    SUMMER_DOOR_CONTROL:"Leto, rad sa kontrolom vrata u letnjem režimu",
    WINTER_DOOR_CONTROL:"Zima, rad sa kontrolom vrata u zimskom režimu",
    APPLY_PARAMETERS_CHANGES:"Primeni promene parametara",
    WORKING_SCHEDULES:"Radno vreme",
    HOLIDAY_SCHEDULES:"Rasporedi praznika",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Praznici na lokaciji uspešno kreirani",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Praznici na lokaciji uspešno ažurirani",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Praznici na lokaciji uspešno obrisani",
    WORKING_SCHEDULES_SUCCESSFULLY_UPDATED:"Radna vremena na lokaciji uspešno ažurirana",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Radna vremena uspešno propagirana",
    HOLIDAY_SUCCESSFULLY_DELETED:"Praznik uspešno obrisan",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:"CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:"CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Sredstvo za sušenje sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_SHAMPOO:"Šampon sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_FOAM:"Pena sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_WAX_1:"Vosak sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_POLISH_1:"Polir sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Sredstvo za čišćenje felni sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_WAX_2:"Vosak sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Sredstvo za sjaj guma sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Sredstvo za uklanjanje insekata sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_POLISH_2:"Polir sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_INTENSIVE:"Intenzivno sredstvo sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Pena za pranje sa niskim nivoom punjenja",
    CHEM_LEVEL_DRYING_AGENT:"Nivo punjenja sredstva za sušenje",
    CHEM_LEVEL_SHAMPOO:"Nivo punjenja šampona",
    CHEM_LEVEL_FOAM:"Nivo punjenja pene",
    CHEM_LEVEL_WAX_1:"Nivo punjenja voska",
    CHEM_LEVEL_POLISH_1:"Nivo punjenja polira",
    CHEM_LEVEL_RIM_CLEANER:"Nivo punjenja sredstva za čišćenje felni",
    CHEM_LEVEL_WAX_2:"Nivo punjenja voska",
    CHEM_LEVEL_TYRE_SHINE:"Nivo punjenja sredstva za sjaj guma",
    CHEM_LEVEL_INSECT_REMOVER:"Nivo punjenja sredstva za uklanjanje insekata",
    CHEM_LEVEL_POLISH_2:"Nivo punjenja polira",
    CHEM_LEVEL_INTENSIVE:"Nivo punjenja intenzivnog sredstva",
    CHEM_LEVEL_FOAM_RAIN:"Nivo punjenja pene za kišu",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Brojač servisa za podizanje kaiša za četku na krovu",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Brojač servisa za podizanje kaiša za sušenje",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Brojač servisa za motorne kablove kaiša za četku na krovu",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Brojač servisa za servisiranje sveže vode",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Brojač servisa za servisiranje korištene vode",
    DRYING_AGENT:"Sredstvo za sušenje",
    FOAM_DRYING_AGENT:"Pena za sušenje",
    SHAMPOO:"Šampon",
    FOAM:"Pena",
    BRUSH_FOAM:"Pena za četkanje",
    WAX_1:"Vosak",
    FOAM_WAX_1:"Pena za vosak",
    POLISH_1:"Polir",
    RIM_CLEANING:"Sredstvo za čišćenje felni",
    WAX_2:"Vosak",
    FOAM_WAX_2:"Pena za vosak",
    TYRE_SHINE:"Sredstvo za sjaj guma",
    INSECT_REMOVER:"Sredstvo za uklanjanje insekata",
    POLISH_2:"Polir",
    INTENSIVE_BASIC:"Intenzivno osnovno",
    INTENSIVE_SIDE:"Intenzivno bočno",
    INTENSIVE_ROOF_SPRAY_BAR:"Intenzivno sredstvo za prskanje krova",
    TAR_REMOVER:"Sredstvo za uklanjanje katrana",
    UNDER_CHASSIS_CONVERSATION:"Razgovor ispod šasije",
    STATIONARY_PRE_SPRAY_ARCH:"Stacionarni pred-prskajući luk",
    FOAM_RAIN:"Pena za kišu",
    PRE_CLEANING:"Predčišćenje",
    BRUSH:"Četka",
    CARE:"Nega",
    DRYING:"Sušenje",
    DRYING_LOW_NOISE:"Smanjeno bučno sušenje",
    INTENSIVE_CLEANING:"Intenzivno čišćenje",
    BRUSH_CLEANING:"Čišćenje četkom",
    EMPTY_RUN:"Pranje bez punjenja",
    DRYING_AID:"Sredstvo za sušenje",
    WAX:"Vosak",
    FOAM_WASH:"Pena za pranje",
    POLISH:"Polir",
    FOAM_POLISH:"Pena za poliranje",
    WHEEL_CLEANING:"Čišćenje točkova",
    HIGH_PRESSURE_ROOF:"Visok pritisak na krovu",
    HIGH_PRESSURE_SIDE:"Visok pritisak sa strane",
    DRYER_FORWARD:"Sušilica napred",
    DRYER_BACKWARD:"Sušilica nazad",
    DELETE_ALL_HOLIDAYS:"Obriši sve praznike za izabranu lokaciju",
    CREATE_NEW_HOLIDAY:"Kreiraj novi",
    RESET_INPUTS:"Resetuj sve ulaze za praznike",
    TWENTY_FOUR_HOURS_OPEN:"Otvoreno 24 sata",
    EVERY_YEAR:"Godišnje",
    DELETE_HOLIDAY:"Obriši praznik",
    ADD_NEW_HOLIDAY:"Dodaj novi praznik",
    HOLIDAYS_LIST:"Spisak postojećih praznika",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Obriši sve praznike za izabranu lokaciju?",
    VALIDATION_HOLIDAY_DATE:"Format nije tačan. Koristite mm-dd",
    VALIDATION_HOLIDAY_YEAR:"Format nije tačan. Koristite yyyy",
    FOR_DATE:"Za datum",
    WITH_ID:"Sa ID",
    FROM_HOURS:"Od (h)",
    FROM_MINUTES:"Od (min)",
    TO_HOURS:"Do (h)",
    TO_MINUTES:"Do (min)",
    NOT_MATCH:"Ne podudara se",
    TO_LESS_THEN_FROM:"Vreme 'Do' mora biti veće ili jednako od vremena 'Od'",
    START:"Od ",
    STOP:"Do",
    DAILY_TIME:"Spisak 24 satne liste",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Individualno podešavanje vremena",
    PROGRAM_NOT_STARTED:"Program još nije započeo",
    JETWASH:"Sistem za samoposluživanje pranja",
    KARCHER_REPORT_1:"Rollover: Turnover indication per program and in total",
    KARCHER_REPORT_2:"Rollover: Started washes per program and in total",
    KARCHER_REPORT_3:"Rollover: Performed washes per program and in total",
    KARCHER_REPORT_4:"Rollover: Amount of started washes via payment terminal per program and in total",
    KARCHER_REPORT_5:"Rollover: Amount of manually started washes per program and in total",
    KARCHER_REPORT_6:" Rollover: Amount of cancelled washes per program and in total",
    KARCHER_REPORT_7:"Rollover: Amount of power supply failures",
    KARCHER_REPORT_8:"SB-Units: Amount of hours per washing program filtered by bay and in total",
    KARCHER_REPORT_9:"SB-Units: Turnover indication per wash bay and in total",
    KARCHER_REPORT_10:"SB-Units: Tokens/Coins counter per coin channel",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Pumpa sveže vode",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Pumpa za procesnu vodu",
    OPERATION_COUNTER_HP_PUMP_1:"Pumpa visokog pritiska 1",
    OPERATION_COUNTER_HP_PUMP_2:"Pumpa visokog pritiska 2",
    RELEASE_NOTES:"Verzije aplikacije i beleške o izdanju",
    BACKEND_RELEASE_NOTES:"Beleške o izdanju platforme:",
    FRONTEND_RELEASE_NOTES:"Beleške o izdanju web aplikacije:",
    SELECTED_FACILITY_TIMEZONE:"Vremenska zona za izabrani objekat:",
    REFRESH_PAGE:"Osveži stranicu",
    REFRESH_MAPS:"Osveži mape",
    PUMPS:"Pumpe",
    RUN_TIME:"Vreme rada",
    RUN_TIME1:"Vreme rada 1",
    RUN_TIME2:"Vreme rada 2",
    PROGRAM_RUNTIME_ACTUATOR:"Aktuator za vreme rada",
    PROGRAM_RUNTIME_ACTUATOR_1:"Aktuator za vreme rada 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Aktuator za vreme rada 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Minimalna vrednost je 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Maksimalna vrednost je 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Koristi format cene x.xx",
    ACTUATION_NOT_ALLOWED:"Aktuacija nije dozvoljena za trenutnu ulogu korisnika",
    MAINTENANCE_DAYS:"Dani održavanja",
    MAINTENANCE_WASHES:"Održavanje pranja",
    DAILY_FINANCES_POS:"POS",
    POS_INCOME:"Ukupni prihod POS",
    PROPAGATE:"Propagirati",
    ALL_DAY_HOURS_SELECTOR:"Selektor tipa 24 sata",
    GET_OPERATING_TIME_FROM_SITE:"Dobijanje vremena rada za trenutni uređaj iz radnog rasporeda lokacije",
    USER_NOT_VALID:"Korisnik nije validan. Pokušajte sa drugim korisničkim podacima.",
    VERIFIED:"Verifikovan",
    RESEND_VERIFICATION_MAIL:"Ponovno slanje email verifikacije",
    RETURN_TO_DASHBOARD:"Povratak na kontrolnu tablu",
    ERROR_PAGE_BAD_REQUEST:"400 Loš zahtev.",
    WASHES:"Broj pranja",
    TIME_TO_SERVICE:"Vreme do servisa",
    ACCOUNT_ALREADY_ACTIVATED:"Nalog već postoji",
    DEVICE_EVENTS:"Događaji uređaja",
    DEVICE_EVENTS_LOG_PULLED:"Povučeni zapisnik događaja za uređaj",
    EVENTS_PULL_DATE:"Vreme povučenih događaja:",
    DEVICE_EVENTS_REFRESH:"Povuci nove podatke o događajima",
    WEB_SOCKETS_CONNECTION_PROBLEM:" Problem sa vezom preko veb soketa. Pokušajte da osvežite stranicu.",
    INSTALLATION_DATE:"Datum instalacije mašine",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Topli vosak",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Pranje pod visokim pritiskom",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Pena za felne",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Snažna pena",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Zaustavi",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Pena pranje HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Pranje",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Vrhunska nega",
    INFO_TITLE:"Informacije",
    FOAM_WAX1:"Pena za vosak",
    POLISH1:"Polir",
    WAX1:"Vosak",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Detalji lokacije uspešno ažurirani",
    COMPANY:"Kompanija",
    FACILITY_HAS_CHANGER:"Da li imate menjač?",
    DISABLE_OFFLINE_ALARM:"Onemogući R2W alarme",
    ASIDE_WORKING_SCHEDULES:" Detalji aplikacije o lokaciji",
    TERMS_OF_SERVICE_R2W_TITLE:"Uslovi korišćenja Ready2Wash-a",
    TERMS_OF_SERVICE_R2W:"Uslovi korišćenja Ready2Wash-a",
    DATA_PROCESSING_TITLE:"Obrađeni podaci",
    PRIVACY_POLICY_TITLE:"Politika privatnosti",
    READY_TO_PAY_TERMS_OF_SERVICE:"Uslovi korišćenja Ready2Pay-a",
    TERMS_AND_SERVICES:"Uslovi i usluge",
    HOURLY: "Svaki sat",
    DAILY: "Dnevno",
    WEEKLY: "Nedeljno",
    MONTHLY: "Mesečno",
    YEARLY: "Godišnje",
    DELETE_ITEM_SUCCESS:"Uspešno ste obrisali izabran element",
    STATE: "Stanje",
    AVAILABILITY_STATUS_1: "Jedinica otvorena",
    AVAILABILITY_STATUS_2: "Jedinica zatvorena (odmor)",
    AVAILABILITY_STATUS_3: "Jedinica zatvorena (radno vreme)",
    AVAILABILITY_STATUS_4: "Jedinica zatvorena (kvar)",
    AVAILABILITY_STATUS_5: "Jedinica zatvorena (ostalo)",
    AVAILABILITY_VACUUMS_STATUS_1: "Usisivači nisu instalirani",
    AVAILABILITY_VACUUMS_STATUS_2: "Usisivači otvoreni",
    AVAILABILITY_VACUUMS_STATUS_3: "Usisivači zatvoreni (odmor)",
    AVAILABILITY_VACUUMS_STATUS_4: "Usisivači zatvoreni (radno vreme)",
    AVAILABILITY_VACUUMS_STATUS_5: "Usisivači zatvoreni (kvar)",
    AVAILABILITY_VACUUMS_STATUS_6: "Usisivači zatvoreni (ostalo)",
    ECOM_AMOUNT: "Ukupan Ecom za sve lokacije",
    CAPTURED: "Zabeleženo",
    DELETE_COMPANY_HISTORY_INFO:"Ova akcija će izbrisati sve podatke o izveštajima vaše kompanije. Ova akcija se ne može poništiti.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Da li ste sigurni da želite trajno izbrisati sve podatke o izveštajima?",
    VALUE_DATE: "Datum valute",
    KARCHER_EVENT_NAME_1: "Osnovni izmenjivač toplote regenerisan",
    KARCHER_EVENT_NAME_2: "Regeneracija osnovnog izmenjivača toplote završena",
    KARCHER_EVENT_NAME_3: "Materijal / serijski broj",
    KARCHER_EVENT_NAME_4: "Sistem je dezinfikovan",
    KARCHER_EVENT_NAME_5: "HP pumpa 1 dezinfikovana",
    KARCHER_EVENT_NAME_6: "HP pumpa 2 dezinfikovana",
    KARCHER_EVENT_NAME_7: "HP pumpa 3 dezinfikovana",
    KARCHER_EVENT_NAME_8: "HP pumpa 4 dezinfikovana",
    KARCHER_EVENT_NAME_9: "HP pumpa 5 dezinfikovana",
    KARCHER_EVENT_NAME_10: "Peraonica 1 zaključana",
    KARCHER_EVENT_NAME_11: "Peraonica 2 zaključana",
    KARCHER_EVENT_NAME_12: "Peraonica 3 zaključana",
    KARCHER_EVENT_NAME_13: "Peraonica 4 zaključana",
    KARCHER_EVENT_NAME_14: "Peraonica 5 zaključana",
    KARCHER_EVENT_NAME_15: "Peraonica 6 zaključana",
    KARCHER_EVENT_NAME_16: "Peraonica 7 zaključana",
    KARCHER_EVENT_NAME_17: "Peraonica 8 zaključana",
    KARCHER_EVENT_NAME_18: "Ažuriranje započeto",
    KARCHER_EVENT_NAME_19: "Ažuriranje završeno",
    KARCHER_EVENT_NAME_20: "Početak WS Reg",
    KARCHER_EVENT_NAME_21: "Kraj WS Reg",
    KARCHER_EVENT_NAME_22: "WS senzor 75%",
    KARCHER_EVENT_NAME_23: "Tehnička greška",
    KARCHER_EVENT_NAME_24: "Operativna greška",
    KARCHER_EVENT_NAME_25: "Jedinica uključena",
    KARCHER_EVENT_NAME_26: "Jedinica isključena",
    KARCHER_EVENT_NAME_27: "Kutija 1 zatvorena",
    KARCHER_EVENT_NAME_28: "Kutija 2 zatvorena",
    KARCHER_EVENT_NAME_29: "Kutija 3 zatvorena",
    KARCHER_EVENT_NAME_30: "Kutija 4 zatvorena",
    KARCHER_EVENT_NAME_31: "Kutija 5 zatvorena",
    KARCHER_EVENT_NAME_32: "Kutija 6 zatvorena",
    KARCHER_EVENT_NAME_33: "Kutija 7 zatvorena",
    KARCHER_EVENT_NAME_34: "Kutija 8 zatvorena",
    KARCHER_EVENT_NAME_35: "Stanica HP pumpe 1",
    KARCHER_EVENT_NAME_36: "Stanica HP pumpe 2",
    KARCHER_EVENT_NAME_37: "Stanica HP pumpe 3",
    KARCHER_EVENT_NAME_38: "Stanica HP pumpe 4",
    KARCHER_EVENT_NAME_39: "Stanica HP pumpe 5",
    KARCHER_EVENT_NAME_40: "Stanica HP pumpe 6",
    KARCHER_EVENT_NAME_41: "Stanica HP pumpe 7",
    KARCHER_EVENT_NAME_42: "Stanica HP pumpe 8",
    KARCHER_EVENT_NAME_43: "Gorionik",
    KARCHER_EVENT_NAME_44: "Ventilator gorionika",
    KARCHER_EVENT_NAME_45: "Pumpa za toplu vodu",
    KARCHER_EVENT_NAME_46: "Pumpa protiv smrzavanja",
    KARCHER_EVENT_NAME_47: "Osmoza pumpa",
    KARCHER_EVENT_NAME_48: "Podno grejanje",
    KARCHER_EVENT_NAME_49: "Grejanje creva",
    KARCHER_EVENT_NAME_50: "Mikro/čišćenje felni",
    KARCHER_EVENT_NAME_51: "Pumpa za pranje šasije",
    KARCHER_EVENT_NAME_52: "Pumpa za penjenje Booster",
    KARCHER_EVENT_NAME_53: "Usisivač 1",
    KARCHER_EVENT_NAME_54: "Usisivač 2",
    KARCHER_EVENT_NAME_55: "Usisivač 3",
    KARCHER_EVENT_NAME_56: "Usisivač 4",
    KARCHER_EVENT_NAME_57: "Usisivač 5",
    KARCHER_EVENT_NAME_58: "Usisivač 6",
    KARCHER_EVENT_NAME_59: "Usisivač 7",
    KARCHER_EVENT_NAME_60: "Usisivač 8",
    KARCHER_EVENT_NAME_61: "Usisivač 9",
    KARCHER_EVENT_NAME_62: "Usisivač 10",
    KARCHER_EVENT_NAME_63: "Usisivač 11",
    KARCHER_EVENT_NAME_64: "Usisivač 12",
    KARCHER_EVENT_NAME_65: "Pumpa za čišćenje felni",
    KARCHER_EVENT_NAME_66: "Mikro pumpa",
    KARCHER_EVENT_NAME_67: "Intenzivna pumpa",
    KARCHER_EVENT_NAME_68: "Turbina usisivača 1",
    KARCHER_EVENT_NAME_69: "Filter usisivača 1",
    KARCHER_EVENT_NAME_70: "Turbina usisivača 2",
    KARCHER_EVENT_NAME_71: "Filter usisivača 2",
    KARCHER_EVENT_NAME_72: "Turbina usisivača 3",
    KARCHER_EVENT_NAME_73: "Filter usisivača 3",
    KARCHER_EVENT_NAME_74: "Turbina usisivača 4",
    KARCHER_EVENT_NAME_75: "Filter usisivača 4",
    KARCHER_EVENT_NAME_76: "Turbina usisivača 5",
    KARCHER_EVENT_NAME_77: "Filter usisivača 5",
    KARCHER_EVENT_NAME_78: "Turbina usisivača 6",
    KARCHER_EVENT_NAME_79: "Filter usisivača 6",
    KARCHER_EVENT_NAME_80: "Turbina usisivača 7",
    KARCHER_EVENT_NAME_81: "Filter usisivača 7",
    KARCHER_EVENT_NAME_82: "Turbina usisivača 8",
    KARCHER_EVENT_NAME_83: "Filter usisivača 8",
    KARCHER_EVENT_NAME_84: "Turbina usisivača 9",
    KARCHER_EVENT_NAME_85: "Filter usisivača 9",
    KARCHER_EVENT_NAME_86: "Turbina usisivača 10",
    KARCHER_EVENT_NAME_87: "Filter usisivača 10",
    KARCHER_EVENT_NAME_88: "Turbina usisivača 11",
    KARCHER_EVENT_NAME_89: "Filter usisivača 11",
    KARCHER_EVENT_NAME_90: "Turbina usisivača 12",
    KARCHER_EVENT_NAME_91: "Filter usisivača 12",
    INSERT_TOKEN: "Unesite tokene i pokrenite uslugu",
    OPEN_SESSION: "Sesija je uspešno otvorena",
    IN_PROGRESS: "U toku ...",
    TOKEN_INSERTED: "Tokeni su uspešno uneseni",
    EXPIRED_SESSION: "Sesija je istekla",
    TWO_DIGIT_INTEGER_VALIDATION: "Koristite najviše dvocifreni ceo broj",
    KARCHER_OPERATION_COUNTER_1: "Stanica za pranje 1 HP pumpa",
    KARCHER_OPERATION_COUNTER_2: "Stanica za pranje 1 hemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_3: "Stanica za pranje 1 hemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_4: "Stanica za pranje 1 hemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_5: "Stanica za pranje 1 hemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_6: "Stanica za pranje 2 HP pumpa",
    KARCHER_OPERATION_COUNTER_7: "Stanica za pranje 2 hemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_8: "Stanica za pranje 2 hemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_9: "Stanica za pranje 2 hemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_10: "Stanica za pranje 2 hemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_11: "Stanica za pranje 3 HP pumpa",
    KARCHER_OPERATION_COUNTER_12: "Stanica za pranje 3 hemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_13: "Stanica za pranje 3 hemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_14: "Stanica za pranje 3 hemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_15: "Stanica za pranje 3 hemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_16: "Stanica za pranje 4 HP pumpa",
    KARCHER_OPERATION_COUNTER_17: "Stanica za pranje 4 hemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_18: "Stanica za pranje 4 hemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_19: "Stanica za pranje 4 hemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_20: "Stanica za pranje 4 hemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_21: "Stanica za pranje 5 HP pumpa",
    KARCHER_OPERATION_COUNTER_22: "Stanica za pranje 5 hemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_23: "Stanica za pranje 5 hemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_24: "Stanica za pranje 5 hemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_25: "Stanica za pranje 5 hemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_26: "Stanica za pranje 6 HP pumpa",
    KARCHER_OPERATION_COUNTER_27: "Stanica za pranje 6 hemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_28: "Stanica za pranje 6 hemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_29: "Stanica za pranje 6 hemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_30: "Stanica za pranje 6 hemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_31: "Stanica za pranje 7 HP pumpa",
    KARCHER_OPERATION_COUNTER_32: "Stanica za pranje 7 hemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_33: "Stanica za pranje 7 hemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_34: "Stanica za pranje 7 hemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_35: "Stanica za pranje 7 hemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_36: "Stanica za pranje 8 HP pumpa",
    KARCHER_OPERATION_COUNTER_37: "Stanica za pranje 8 hemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_38: "Stanica za pranje 8 hemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_39: "Stanica za pranje 8 hemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_40: "Stanica za pranje 8 hemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_41: "Pumpa za osmozu",
    KARCHER_OPERATION_COUNTER_42: "Generator tople vode",
    KARCHER_OPERATION_COUNTER_43: "Pumpa za zaštitu od smrzavanja",
    KARCHER_OPERATION_COUNTER_44: "WSO filter patrone",
    KARCHER_OPERATION_COUNTER_45: "Pumpa za grejanje stanice za pranje",
    KARCHER_OPERATION_COUNTER_46: "Pumpa za toplu vodu",
    KARCHER_OPERATION_COUNTER_47: "Grejač za penu u crevima",
    KARCHER_OPERATION_COUNTER_48: "Pumpa za pranje točkova",
    KARCHER_OPERATION_COUNTER_49: "Mikroemulziona pumpa",
    KARCHER_OPERATION_COUNTER_50: "Intenzivna pumpa za penu",
    KARCHER_OPERATION_COUNTER_51: "Usisivač 1 turbina 1",
    KARCHER_OPERATION_COUNTER_52: "Usisivač 1 filter 1",
    KARCHER_OPERATION_COUNTER_53: "Usisivač 1 turbina 2",
    KARCHER_OPERATION_COUNTER_54: "Usisivač 1 filter 2",
    KARCHER_OPERATION_COUNTER_55: "Usisivač 2 turbina 1",
    KARCHER_OPERATION_COUNTER_56: "Usisivač 2 filter 1",
    KARCHER_OPERATION_COUNTER_57: "Usisivač 2 turbina 2",
    KARCHER_OPERATION_COUNTER_58: "Usisivač 2 filter 2",
    KARCHER_OPERATION_COUNTER_59: "Usisivač 3 turbina 1",
    KARCHER_OPERATION_COUNTER_60: "Usisivač 3 filter 1",
    KARCHER_OPERATION_COUNTER_61: "Usisivač 3 turbina 2",
    KARCHER_OPERATION_COUNTER_62: "Usisivač 3 filter 2",
    KARCHER_OPERATION_COUNTER_63: "Usisivač 4 turbina 1",
    KARCHER_OPERATION_COUNTER_64: "Usisivač 4 filter 1",
    KARCHER_OPERATION_COUNTER_65: "Usisivač 4 turbina 2",
    KARCHER_OPERATION_COUNTER_66: "Usisivač 4 filter 2",
    KARCHER_OPERATION_COUNTER_67: "Usisivač 5 turbina 1",
    KARCHER_OPERATION_COUNTER_68: "Usisivač 5 filter 1",
    KARCHER_OPERATION_COUNTER_69: "Usisivač 5 turbina 2",
    KARCHER_OPERATION_COUNTER_70: "Usisivač 5 filter 2",
    KARCHER_OPERATION_COUNTER_71: "Usisivač 6 turbina 1",
    KARCHER_OPERATION_COUNTER_72: "Usisivač 6 filter 1",
    KARCHER_OPERATION_COUNTER_73: "Usisivač 6 turbina 2",
    KARCHER_OPERATION_COUNTER_74: "Usisivač 6 filter 2",
    KARCHER_OPERATION_COUNTER_75: "Ispustite vodu iz kondenzacije iz kompresora",
    KARCHER_OPERATION_COUNTER_76: "Proverite sistem protiv smrzavanja",
    KARCHER_OPERATION_COUNTER_77: "Ventilator gorionika",
    KARCHER_OPERATION_COUNTER_78: "Pumpa za pojačanje pene",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Lista podataka je veća od 10000 stavki",
    KARCHER_POINT_NAME_1: "Praznik",
    KARCHER_POINT_NAME_2: "Ponedeljak",
    KARCHER_POINT_NAME_3: "Utorak",
    KARCHER_POINT_NAME_4: "Sreda",
    KARCHER_POINT_NAME_5: "Četvrtak",
    KARCHER_POINT_NAME_6: "Petak",
    KARCHER_POINT_NAME_7: "Subota",
    KARCHER_POINT_NAME_8: "Nedelja",
    KARCHER_POINT_NAME_9: "Usisivači Praznik",
    KARCHER_POINT_NAME_10: "Usisivači Ponedeljak",
    KARCHER_POINT_NAME_11: "Usisivači Utorak",
    KARCHER_POINT_NAME_12: "Usisivači Sreda",
    KARCHER_POINT_NAME_13: "Usisivači Četvrtak",
    KARCHER_POINT_NAME_14: "Usisivači Petak",
    KARCHER_POINT_NAME_15: "Usisivači Subota",
    KARCHER_POINT_NAME_16: "Usisivači Nedelja",
    KARCHER_POINT_NAME_17: "Osvetljenje Praznik",
    KARCHER_POINT_NAME_18: "Osvetljenje Ponedeljak",
    KARCHER_POINT_NAME_19: "Osvetljenje Utorak",
    KARCHER_POINT_NAME_20: "Osvetljenje Sreda",
    KARCHER_POINT_NAME_21: "Osvetljenje Četvrtak",
    KARCHER_POINT_NAME_22: "Osvetljenje Petak",
    KARCHER_POINT_NAME_23: "Osvetljenje Subota",
    KARCHER_POINT_NAME_24: "Osvetljenje Nedelja",
    KARCHER_POINT_NAME_25: "Program 0",
    KARCHER_POINT_NAME_26: "Program 1",
    KARCHER_POINT_NAME_27: "Program 2",
    KARCHER_POINT_NAME_28: "Program 3",
    KARCHER_POINT_NAME_29: "Program 4",
    KARCHER_POINT_NAME_30: "Program 5",
    KARCHER_POINT_NAME_31: "Program 6",
    KARCHER_POINT_NAME_32: "Program 7",
    KARCHER_POINT_NAME_33: "Program 8",
    KARCHER_POINT_NAME_34: "Program 9",
    KARCHER_POINT_NAME_35: "Program 10",
    KARCHER_POINT_NAME_36: "Program 11",
    KARCHER_POINT_NAME_37: "Program 12",
    KARCHER_POINT_NAME_38: "Program 13",
    KARCHER_POINT_NAME_39: "Program 14",
    KARCHER_POINT_NAME_40: "Program 15",
    KARCHER_POINT_NAME_41: "Program 16",
    KARCHER_POINT_NAME_42: "Program 17",
    KARCHER_POINT_NAME_43: "Program 18",
    KARCHER_POINT_NAME_44: "Program 19",
    KARCHER_POINT_NAME_45: "Program 20",
    KARCHER_POINT_NAME_46: "Program 21",
    KARCHER_POINT_NAME_47: "Program 22",
    KARCHER_POINT_NAME_48: "Program 23",
    KARCHER_POINT_NAME_49: "Program 24",
    KARCHER_POINT_NAME_50: "Program 25",
    KARCHER_POINT_NAME_51: "Program 26",
    KARCHER_POINT_NAME_52: "Program 27",
    KARCHER_POINT_NAME_53: "Program 28",
    KARCHER_POINT_NAME_54: "Program 29",
    KARCHER_POINT_NAME_55: "Program 30",
    KARCHER_POINT_NAME_56: "Program 31",
    KARCHER_POINT_NAME_57: "Program 32",
    QR_CODE: "QR kod",
    ACCEPT_TERMS_AND_CONDITIONS: "Prihvati uslove korišćenja",
    CREATE_AND_PRINT_VOUCHERS: "Kreiraj i štampaj vaučere",
    CREATE_AND_PRINT_VOUCHERS_VACC: "Kreiraj i štampaj vaučere - Usisivač",
    CREATE_AND_PRINT_VOUCHERS_JET_WASH: "Kreiraj i štampaj vaučere - Jet Wash Care",
    CODE_PREFIX_QUESTION: "Prefiks kod nije unet",
    CODE_PREFIX_QUESTION_TEXT: "Želite li da nastavite bez prefiks koda?",
    ISSUED_DATE: "Datum izdavanja",
    DAYS_LABEL: "Rok važenja vaučera (u danima)",
    VOUCHER_VALIDITY_DAYS: "Rok važenja vaučera (dani)",
    ROLLOVER_VOUCHER_VALIDITY_DAYS: "Rok važenja rollover vaučera (dani)",
    VALIDATION_ONLY_NUMBERS: "Dozvoljen je unos samo brojeva",
    REPRINT_VOUCHERS: "Štampaj kopiju vaučera",
    EXPIRY_DATE: "Važi do",
    VOUCHER_EXPIRATION_DAYS_UPDATED: "Broj dana važenja vaučera je uspešno ažuriran",
    ROLLOVER_VOUCHER_EXPIRATION_DAYS_UPDATED: "Rok važenja rollover vaučera je uspešno ažuriran",
    ASIDE_MENU_ROLLOVER: "Rollover vaučeri",
    ROLLOVER_WELCOME_TITLE: "Izbor Rollover uređaja",
    ROLLOVER_SITE: "Lokacija",
    ROLLOVER_SITE_NAME_PLACEHOLDER: "Vaša lokacija",
    ROLLOVER_SELECT_DEVICE: "Izaberite Rollover uređaj",
    ROLLOVER_NO_DEVICES: "Nema dostupnih rollover uređaja na ovoj lokaciji",
    ROLLOVER_STATUS_ONLINE: "Online",
    ROLLOVER_STATUS_OFFLINE: "Offline",
    ROLLOVER_PROGRAMS_AVAILABLE: "dostupnih programa",
    ROLLOVER_DEVICE_UNAVAILABLE: "Uređaj nije dostupan",
    ROLLOVER_SELECT: "Izaberi",
    ROLLOVER_PROGRAM_SELECTION: "Izbor programa",
    ROLLOVER_DEVICE: "Uređaj",
    ROLLOVER_SELECT_PROGRAM: "Izaberite program",
    ROLLOVER_NO_PROGRAMS: "Nema dostupnih programa za ovaj uređaj",
    ROLLOVER_CHOOSE_PROGRAM: "Izaberi program",
    ROLLOVER_PROGRAMS: "Programi",
    ROLLOVER_OPTIONS: "Opcije",
    ROLLOVER_SELECT_OPTION: "Izaberi opciju",
    ROLLOVER_OPTIONS_SELECTION: "Izbor opcija",
    ROLLOVER_SELECTED_PROGRAM: "Izabrani program",
    ROLLOVER_NO_OPTIONS: "Nema dostupnih opcija za ovaj program",
    ROLLOVER_TOTAL_PRICE: "Ukupna cena",
    ROLLOVER_CONFIRM_SELECTION: "Potvrdi izbor",
    ROLLOVER_SELECT_OPTIONS: "Izaberi opcije",
    ROLLOVER_CONFIGURATION: "Konfiguracija",
    ROLLOVER_SUMMARY: "Rezime",
    ROLLOVER_PROGRAM: "Program",
    ROLLOVER_SELECT_PROGRAM_HINT: "Izaberite program sa liste da vidite dostupne opcije",
    ROLLOVER_SALES_TYPE: "Tip prodaje",
    ROLLOVER_NUMBER_OF_WASHES: "Broj pranja",
    ROLLOVER_WASHES: "pranja",
    ROLLOVER_VALIDITY_PERIOD: "Period važenja",
    ROLLOVER_VALID_FROM: "Važi od",
    ROLLOVER_VALIDITY_DAYS: "Dani",
    ROLLOVER_VALID_TO: "Važi do",
    ROLLOVER_HAPPY_HOUR: "Happy Hour",
    ROLLOVER_HAPPY_HOUR_PERIOD_1: "Period 1",
    ROLLOVER_HAPPY_HOUR_PERIOD_2: "Period 2",
    ROLLOVER_START_TIME: "Vreme početka",
    ROLLOVER_END_TIME: "Vreme kraja",
    ROLLOVER_INVALID_TIME_FORMAT: "Neispravan format. Koristite HH:mm (npr. 08:00, 23:59)",
    ROLLOVER_END_MUST_BE_AFTER_START: "Vreme kraja mora biti posle vremena početka",
    ROLLOVER_PRINT: "Štampaj",
    ROLLOVER_CREATE_AND_PRINT: "Kreiraj i odštampaj vaučer",
    ROLLOVER_VIEW_VOUCHERS: "Pregledaj vaučere",
    ROLLOVER_CREATE_VOUCHER: "Kreiraj vaučer",
    ROLLOVER_VOUCHERS: "Pregled rollover vaučera",
    ROLLOVER_NO_VOUCHERS: "Nema izdatih vaučera na ovoj lokaciji",
    ROLLOVER_SEARCH_VOUCHERS_PLACEHOLDER: "Pretraži vaučere po kodu ili izdavaču",
    ROLLOVER_SEARCH_VOUCHERS: "Pretraži vaučere",
    ROLLOVER_VOUCHER_CODE: "Kod vaučera",
    ROLLOVER_VOUCHER_STATUS: "Status",
    ROLLOVER_VOUCHER_TOKENS: "Pranja",
    ROLLOVER_VOUCHER_REDEEMED: "Iskorišćeno",
    ROLLOVER_VOUCHER_ISSUED_DATE: "Datum izdavanja",
    ROLLOVER_VOUCHER_EXPIRES: "Ističe",
    ROLLOVER_VOUCHER_ISSUED_BY: "Izdato od",
    ROLLOVER_VOUCHER_ACTION: "Napomena",
    ROLLOVER_VOUCHER_ACTIONS: "Akcije",
    ROLLOVER_DEACTIVATE_VOUCHER: "Deaktiviraj vaučer",
    ROLLOVER_DEACTIVATE_TITLE: "Deaktivacija vaučera",
    ROLLOVER_DEACTIVATE_CONFIRM: "Da li ste sigurni da želite deaktivirati ovaj vaučer?",
    ROLLOVER_VALIDITY_FROM: "Važi od",
    ROLLOVER_VALIDITY_FROM_HINT: "Ostavite prazno za trenutnu validnost",
    ROLLOVER_PRINT_VOUCHER: "Štampaj vaučer",
    ROLLOVER_REMAINING_WASHES: "Preostala pranja",
    ROLLOVER_CANCEL: "Otkaži",
    ROLLOVER_CREATING: "Kreiranje...",
    ROLLOVER_OPTIONS_SELECTED: "Izabrane opcije",
    ROLLOVER_SALES_TYPES: "Tipovi prodaje",
    ROLLOVER_SELECT_REPORT: "Izaberi izveštaj",
    ROLLOVER_STAT_WASHING_PROGRAMS: "Programi pranja",
    ROLLOVER_STAT_PROGRAM_NAME: "Naziv programa pranja",
    ROLLOVER_STAT_PRICE: "Cena",
    ROLLOVER_STAT_SELL_BY_DATE: "Datum prodaje",
    ROLLOVER_STAT_VALID_FROM: "Važi od",
    ROLLOVER_STAT_VALID_TO: "Važi do",
    ROLLOVER_STAT_CODE: "Kod",
    ROLLOVER_STAT_NUM_WASHES: "Broj pranja",
    ROLLOVER_STAT_VACANT: "Slobodno",
    ROLLOVER_STAT_CODE_BLOCKAGE: "Blokada koda",
    ROLLOVER_STAT_DURATION_CODE: "Trajanje koda",
    ROLLOVER_STAT_UNDER_CHASSIS: "Pranje podvozja",
    ROLLOVER_STAT_TRANSPORTER: "Transporter",
    ROLLOVER_STAT_PRE_WASH: "Predpranje",
    ROLLOVER_STAT_POST_WASH: "Završno pranje",
    ROLLOVER_STAT_RIM_CLEANER: "Čistač felni",
    ROLLOVER_STAT_WAX1: "Vosak 1",
    ROLLOVER_STAT_WAX2: "Vosak 2",
    ROLLOVER_STAT_HAPPY_HOUR1: "Happy Hour 1",
    ROLLOVER_STAT_HAPPY_HOUR2: "Happy Hour 2",
    ROLLOVER_STAT_TIME_FROM: "Vreme od",
    ROLLOVER_STAT_TIME_TO: "Vreme do",
    ROLLOVER_STAT_CASH_REGISTER: "Kasa",
    ROLLOVER_STAT_SALES_TYPE: "Tip prodaje",
    ROLLOVER_STAT_POINT_IN_TIME: "Vreme",
    ROLLOVER_ISSUED_WASHES: "Izdata pranja",
    ROLLOVER_EXECUTED_WASHES: "Izvršena pranja",
    ROLLOVER_DATE_FROM: "Datum od",
    ROLLOVER_DATE_TO: "Datum do",
    ROLLOVER_NO_STATISTICS_DATA: "Nema dostupnih statističkih podataka",
    ROLLOVER_SALES_TYPE_ACTIVE: "Aktivan",
    ROLLOVER_SALES_TYPE_UPDATED: "Tip prodaje uspešno ažuriran",
    ROLLOVER_NO_SALES_TYPES: "Nema dostupnih tipova prodaje",
    ROLLOVER_ZERO_PRICE: "Nulta cena",
    ROLLOVER_SPECIAL_OFFER_PRICES: "Cene specijalne ponude",
    ROLLOVER_UNLIMITED_WASHES: "Neograničena pranja",
    ACTIVE: "Aktivan",
    INACTIVE: "Neaktivan",
    SUCCESS: "Uspeh",
    ASIDE_MENU_SAVINGS: "Štednja",
    SAVINGS_TITLE: "Računi za štednju",
    SAVINGS_DESCRIPTION: "Upravljajte računima za štednju korisnika sa SAVINGS porekla",
    SAVINGS_SEARCH_PLACEHOLDER: "Pretraži po ID korisnika ili kompaniji",
    SAVINGS_USERS_LIST: "Korisnici za štednju",
    SAVINGS_NO_USERS: "Nisu pronađeni korisnici za štednju",
    SAVINGS_USER_ID: "ID korisnika",
    SAVINGS_COMPANY: "Kompanija",
    SAVINGS_BALANCE: "Stanje",
    SAVINGS_INITIAL_CREDIT: "Početni kredit",
    SAVINGS_REMAINING_CREDIT: "Preostali kredit",
    SAVINGS_CREATED_DATE: "Datum kreiranja",
    SAVINGS_STATUS: "Status",
    SAVINGS_EXPIRATION_DATE: "Datum isteka",
    SAVINGS_POSTPAID: "Postpaid",
    SAVINGS_ACTIONS: "Akcije",
    SAVINGS_DEACTIVATE: "Deaktiviraj",
    SAVINGS_DEACTIVATE_TITLE: "Deaktiviraj račun za štednju",
    SAVINGS_DEACTIVATE_MESSAGE: "Da li ste sigurni da želite da deaktivirate ovaj račun za štednju?",
    SAVINGS_PACKAGES: "Paketi štednje",
    SAVINGS_CREDIT_AMOUNT: "Iznos kredita",
    SAVINGS_EXPIRATION_DAYS: "Dani važenja štednje",
    SAVINGS_EXPIRATION_DAYS_UPDATED: "Dani važenja štednje su uspešno ažurirani",
    IDENTIFICATION_CODE: "Identifikacioni kod",
    SAVINGS_CREATE_TITLE: "Kreiraj novog korisnika",
    SAVINGS_SALE_TYPE: "Tip prodaje",
    SAVINGS_SALE_TYPE_REGULAR: "Regularni",
    SAVINGS_SALE_TYPE_POSTPAID: "Postpaid",
    SAVINGS_SALE_TYPE_PACKAGE: "Paket",
    SAVINGS_SELECT_PACKAGE: "Izaberi paket",
    SAVINGS_PACKAGE: "Paket",
    SAVINGS_AMOUNT: "Iznos",
    SAVINGS_VALIDITY_PERIOD: "Period važenja",
    SAVINGS_VALID_FROM: "Važi od",
    SAVINGS_VALID_TO: "Važi do",
    SAVINGS_VALIDITY_DAYS: "Dani važenja",
    SAVINGS_SUMMARY: "Rezime",
    SAVINGS_CREATE_AND_PRINT: "Kreiraj i štampaj",
    SAVINGS_CREATE_AND_PRINT_REMOTE: "Kreiraj i štampaj udaljeno",
    SAVINGS_CREATING: "Kreiranje...",
    SAVINGS_REMOTE_PRINT: "Udaljena štampa",
    SAVINGS_REMOTE_PRINT_TITLE: "Udaljena štampa štednje",
    SAVINGS_REMOTE_PRINT_DESCRIPTION: "Izaberite lokaciju i menjačnicu za udaljenu štampu {{code}}.",
    SAVINGS_REMOTE_PRINT_SITE: "Lokacija",
    SAVINGS_REMOTE_PRINT_DEVICE: "Menjačnica",
    SAVINGS_REMOTE_PRINT_NO_CHANGERS: "Na izabranoj lokaciji nema dostupnih menjačnica.",
    SAVINGS_REMOTE_PRINT_ERROR_SITES: "Ne možemo da učitamo lokacije za vašu kompaniju.",
    SAVINGS_REMOTE_PRINT_ERROR_DEVICES: "Ne možemo da učitamo menjačnice za izabranu lokaciju.",
    SAVINGS_REMOTE_PRINT_ERROR_GENERIC: "Udaljena štampa nije uspela. Pokušajte ponovo.",
    SAVINGS_REMOTE_PRINT_ERROR_DEVICE_NOT_CHANGER: "Izabrani uređaj nije menjačnica.",
    SAVINGS_REMOTE_PRINT_ERROR_DEVICE_OFFLINE: "Izabrana menjačnica je trenutno van mreže.",
    SAVINGS_REMOTE_PRINT_ERROR_DEVICE_NOT_ON_SITE: "Izabrana menjačnica ne pripada ovoj lokaciji.",
    SAVINGS_REMOTE_PRINT_ERROR_IN_PROGRESS: "Udaljena štampa je već u toku za ovaj kod.",
    SAVINGS_REMOTE_PRINT_ERROR_TIMEOUT: "Isteklo je vreme za udaljenu štampu. Pokušajte ponovo.",
    SAVINGS_REMOTE_PRINT_ERROR_FAILED: "Udaljena štampa na uređaju nije uspela.",
    SAVINGS_REMOTE_PRINT_ACTION: "Pošalji na menjačnicu",
    SAVINGS_REMOTE_PRINT_SUCCESS: "Zahtev za udaljenu štampu je uspešno poslat.",
    SAVINGS_TAB_USERS: "Korisnici",
    SAVINGS_TAB_GROUPS: "Postpaid grupa",
    SAVINGS_GROUPS_LIST: "Postpaid grupa",
    SAVINGS_CREATE_GROUP: "Kreiraj grupu",
    SAVINGS_GROUP_SEARCH_PLACEHOLDER: "Pretraži po imenu grupe ili opisu",
    SAVINGS_NO_GROUPS: "Nisu pronađene pospaid grupe",
    SAVINGS_GROUP_NAME: "Naziv grupe",
    SAVINGS_GROUP_DESCRIPTION: "Opis",
    SAVINGS_GROUP_MEMBERS: "Članovi",
    SAVINGS_GROUP_DETAILS: "Detalji grupe",
    SAVINGS_GROUP_USER_SPENDING: "Potrošnja korisnika",
    SAVINGS_TOTAL_USERS: "Ukupno korisnika",
    SAVINGS_TOTAL_SPENT: "Ukupno potrošeno",
    SAVINGS_TOTAL_TOPUPS: "Ukupno dopuna",
    SAVINGS_TOTAL_BALANCE: "Ukupan saldo",
    SAVINGS_NO_USERS_IN_GROUP: "Nema korisnika u ovoj grupi",
    SAVINGS_USER_NAME: "Ime korisnika",
    SAVINGS_TRANSACTION_COUNT: "Transakcije",
    SAVINGS_LAST_TRANSACTION: "Poslednja transakcija",
    SAVINGS_DATE_FROM: "Datum od",
    SAVINGS_DATE_TO: "Datum do",
    SAVINGS_USER_TRANSACTIONS: "Transakcije korisnika",
    SAVINGS_TX_SITE: "Lokacija",
    SAVINGS_TX_DEVICE: "Uređaj",
    SAVINGS_TX_AMOUNT: "Iznos",
    SAVINGS_TX_DATE: "Datum",
    SAVINGS_EDIT_TITLE: "Izmeni korisnika štednje",
    SAVINGS_USER_INFO: "Informacije o korisniku",
    SAVINGS_CURRENT_CREDIT: "Trenutni kredit",
    SAVINGS_NEW_CREDIT: "Novi kredit",
    SAVINGS_LOAD_ERROR: "Greška pri učitavanju računa štednje",
    SAVINGS_EDIT_SUCCESS: "Račun štednje uspešno ažuriran",
    SAVINGS_EDIT_ERROR: "Greška pri ažuriranju računa štednje",
    SAVINGS_TAB_REPORTS: "Izveštaji",
    SAVINGS_REPORTS_TITLE: "Izveštaji štednje",
    SAVINGS_REPORTS_NOTE: "Napomena: Štednja isključuje Happy Hour (bez duplih popusta)",
    SAVINGS_REPORTS_SELECT_PERIOD: "Izaberite period i kliknite Pretraži",
    SAVINGS_REPORT_REVENUE_BY_SALES_TYPE: "Prihod po tipu prodaje",
    SAVINGS_REPORT_ISSUED_CREDIT_BY_SALES_TYPE: "Izdati kredit po tipu prodaje",
    SAVINGS_REPORT_REDEEMED_BY_DEVICE_TYPE: "Iskorišćena štednja po tipu uređaja",
    SAVINGS_SALES_TYPE: "Tip prodaje",
    SAVINGS_DEVICE_TYPE: "Tip uređaja",
    DEVICE_TYPE_SEMPRA_BRIDGE: "Sempra Bridge",
    DEVICE_TYPE_SERIAL_485: "Serial 485",
    DEVICE_TYPE_CHANGER: "Menjačnica",
    DEVICE_TYPE_BRIDGE_WITH_LISTENER: "Bridge sa Listenerom",
    DEVICE_TYPE_KARCHER: "Kärcher",
    DEVICE_TYPE_HHANLE: "Hermann Hänle",
    DEVICE_TYPE_SB_OB: "SB OB",
    DEVICE_TYPE_SB_MU_MB: "SB MU MB",
    DEVICE_TYPE_CW1: "CW1",
    DEVICE_TYPE_CW3: "CW3",
    DEVICE_TYPE_CW35: "CW35",
    DEVICE_TYPE_CB3: "CB3",
    DEVICE_TYPE_ST_JETWASH: "Jetwash",
    DEVICE_TYPE_ST_ROLLOVER: "Rollover",
    DEVICE_TYPE_ADYEN_BRIDGE: "Adyen Bridge",
    DEVICE_TYPE_POS2VP: "POS2VP",
    DEVICE_TYPE_POS2PLC: "POS2PLC",
    DEVICE_TYPE_POS2IMPULS: "POS2IMPULS",
    DEVICE_TYPE_ROLLOVER_BRIDGE: "Rollover Bridge",
    DEVICE_TYPE_ALTA_PRO: "Alta Pro",
    DEVICE_TYPE_UNKNOWN: "Nepoznato",
    ROLLOVER_SEARCH_VOUCHER_PLACEHOLDER: "Unesite kod vaučera...",
    ROLLOVER_SEARCH: "Pretraži",
    ROLLOVER_VOUCHER_NOT_FOUND: "Vaučer nije pronađen",
    ROLLOVER_VOUCHER_SEARCH_ERROR: "Greška pri pretrazi vaučera",
    ROLLOVER_VOUCHER_DETAILS: "Detalji vaučera",
    ROLLOVER_PURCHASE_DATE: "Datum kupovine",
    ROLLOVER_VALIDITY_START: "Početak važenja",
    ROLLOVER_VALIDITY_END: "Kraj važenja",
    ROLLOVER_BLOCKED_STATUS: "Status blokiranja",
    ROLLOVER_WASH_PROGRAM: "Broj programa pranja",
    ROLLOVER_SELECTED_OPTIONS: "Izabrane opcije",
    ROLLOVER_WASHES_SOLD: "Broj prodatih pranja (početno)",
    ROLLOVER_WASHES_AVAILABLE: "Broj dostupnih pranja (preostalo)",
    ROLLOVER_UNLIMITED: "Neograničeno",
    ROLLOVER_REDEMPTION_HISTORY: "Istorija iskorišćavanja",
    ROLLOVER_NO_REDEEMS: "Nema zabeleženih iskorišćavanja",
    ROLLOVER_REDEEM_DATE: "Datum",
    ROLLOVER_REDEEM_SITE: "Lokacija",
    ROLLOVER_REDEEM_DEVICE: "Uređaj",
    ROLLOVER_STATUS_ACTIVE: "Aktivan",
    ROLLOVER_STATUS_REDEEMED: "Iskorišćen",
    ROLLOVER_STATUS_EXPIRED: "Istekao",
    ROLLOVER_STATUS_BLOCKED: "Blokiran",
    ROLLOVER_PRINT_CONFIRMATION: "Potvrda štampe",
    ROLLOVER_PRINT_UNSUCCESSFUL_MESSAGE: "Ako štampa nije bila uspešna, molimo koristite kod ispod.",
    ROLLOVER_DEACTIVATE: "Deaktiviraj",
    ROLLOVER_PRINT_AGAIN: "Štampaj ponovo",
    CONFIRM: "Potvrdi",
    CLOSE: "Zatvori",
    VOUCHER_TYPE_VACUUM: "Vaučer za: Usisivač",
    VOUCHER_TYPE_JETWASH: "Vaučer za: Jet Wash Care",
    VOUCHER_TYPE_MATT: "Vaučer za: Matt",
    ROLLOVER_VOUCHERS_MANAGEMENT: "Upravljanje vaučerima",
    ROLLOVER_VOUCHERS_REPORT: "Izveštaj o vaučerima",
    ROLLOVER_REPORT_CHART: "Grafički prikaz",
    ROLLOVER_REPORT_TABLE: "Tabelarni prikaz",
    REPORT_DATE_FROM: "Datum od",
    REPORT_DATE_TO: "Datum do",
    REPORT_TIME_UNIT: "Vremenska jedinica",
    TIME_UNIT_DAY: "Dan",
    TIME_UNIT_HOUR: "Sat",
    REPORT_TYPE: "Tip izveštaja",
    ROLLOVER_WASHES_PERFORMED: "Izvršena pranja",
    ROLLOVER_WASHES_NOT_PERFORMED: "Neizvršena pranja",
    ROLLOVER_WASHES_EXPIRED: "Istekla pranja",
    ROLLOVER_OPTIONS_SOLD: "Prodate opcije",
    ROLLOVER_REVENUE: "Prihod",
    ROLLOVER_HAPPY_HOUR_PERIODS: "Happy Hour periodi (šrafirane oblasti)",
    ROLLOVER_TOTAL_SOLD: "Ukupno prodato",
    ROLLOVER_TOTAL_PERFORMED: "Ukupno izvršeno",
    ROLLOVER_TOTAL_NOT_PERFORMED: "Ukupno neizvršeno",
    ROLLOVER_TOTAL_EXPIRED: "Ukupno isteklo",
    ROLLOVER_TOTAL_REVENUE: "Ukupan prihod",
    ROLLOVER_PROGRAMS_STATS: "Statistika po programu",
    ROLLOVER_OPTIONS_STATS: "Statistika po opciji",
    ROLLOVER_DETAILED_DATA: "Detaljni podaci",
    ROLLOVER_NO_STATS_DATA: "Nema dostupnih statističkih podataka",
    ROLLOVER_SELECT_DATES_AND_SEARCH: "Izaberite opseg datuma i kliknite Pretraži",
    EXPORT_CSV: "Izvezi u CSV",
    PROGRAM: "Program",
    OPTION: "Opcija",
    TOTAL: "Ukupno"
  });
})();